import {
  InmateDetailsContainer,
  StyledActionControlContainer,
  StyledDarkSectionTitle,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import BookingsDetails from "@/components/BookingsDetails";
import Loader from "@/common/elements/Loader";
import { StyledBookingsContainer, StyledBookingsContent } from "./styles";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { ActionHeader } from "../CreateBooking/styles";
import Button from "@/common/elements/Button";
import { useDispatch, useSelector } from "react-redux";
import { Flex, Form, Input, Spin, message, Tooltip, Modal, Popconfirm } from "antd";
import {
  setBookings,
  setBookingsFieldsEnabled,
  setBookingsNull,
  setJacketFlags,
  setDeleteAPIEmpty,
  setIrisEnrolleId,
  setIrisSearchId,
  setIsScheduledBooking,
  setLastBookingsFromAPI,
  setShowBookings,
} from "@/slices/bookingsSlice";
import { setisSearchFilterActionTriggered } from "@/slices/userDetailDetail";
import api from "@/services/axios_custom";
import API_ENDPOINTS, { WEB_SOCKET_URL } from "@/util/api";
import {
  getDayjsObject,
  getLatestBookingsUtil,
  hasCheckSecurity,
  isNonEmptyVariable,
  toQueryString,
  deepReplaceEmptyWithNull,
  getRefListNameByID,
} from "@/util/common_function";
import {
  saveBioAndArrestReportsExtra,
  saveInmatePropertyExtra,
  saveInmateMedicalExtra,
  saveBookingBailsExtra,
  saveHoldsExtra,
  saveInmateMovementRulesExtra,
  saveInmateTrackingExtra,
  saveInmatePropertyItemsExtra,
  saveAppointmentLogExtra,
  saveBioAddressesExtra,
  saveBusinessesExtra,
  saveCashAccountingNewExtra,
  saveCashAccountingNewTransactionsExtra,
  saveMedicationLogExtra,
  saveScheduledEventsExtra,
  saveVictimNotificationExtra,
  saveVictimNotificationLogExtra,
  fetchAndMergeBookingExtras,
} from "@/util/extraColumnActions";
import notificationService from "@/util/notificationService";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import _ from "lodash";
import useDialog from "@/hooks/useDialog";
import {
  mandatoryFields,
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import { getOptionsFromRefList } from "@/util/common_function";
import axios from "axios";
import DropdownButton from "@/common/elements/DropdownButton";
import { ROUTES_PATH } from "@/routes";
import ReportList, { REPORT_LIST_HEADERS } from "./ReportList";
import useGridColumnConfig from "@/hooks/useGridColumnConfig";
import BookingsFilter from "./filter";
import {
  Arbitrary_Names,
  Entity_types,
  Security_Types,
} from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import NoAccess from "@/components/BookingsDetails/NoAccess";
import HouseAndTracksForm from "@/components/HouseandTracking/HouseAndTrackingForm";
import {
  getNewTransportTriggeringEntries,
  buildTransportPayloads,
  createTransportsForNewMovements,
  cancelPendingTransportsForJacket,
} from "@/util/transportAutoCreate";
import {
  getRecurringChainScheduledEvents,
  syncScheduledEventsInmateTracking,
} from "@/util/scheduledEventMovementAutoCreate";
import { syncChargesCourtInmateTracking } from "@/util/inmateTrackingSync";
import { REF_LIST_CODE } from "@/util/refList";
import { setFullSearch } from "@/slices/fullSearchSlice";
import { ReportModalContext } from "@/contexts/ReportModalContext";
import { useContext } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { useIrisDevice } from "@/hooks/useIrisDevice";
import SearchIrisDetailsPopup from "@/components/InmateDetails/SearchIrisDetailsPopup";
import {
  mergeFlagsIntoInvolvements,
  getAllInvolvements,
  sanitizeInvolvementsForSave,
  excludeQuestionnaireInvolvements,
} from "@/components/BookingsDetails/JacketDetails/flagUtils";

const { Search } = Input;

const UNRELEASED_DATE = "1900-01-01T00:00:00";

const BookingsPage = forwardRef(
  (
    {
      isBQ = false,
      nextBookingStep = null,
      bqCompleteSaveAction,
      fromBookingStep = false,
      fromFolderDetails = false,
      // Lets a parent that renders this page inside its own Modal (Booking
      // Queue / Release Queue step modals) put Save/Cancel in the modal's real
      // footer instead of this page's inline action bar - see triggerSave /
      // triggerCancel exposed below via useImperativeHandle.
      onFooterStateChange,
    },
    ref,
  ) => {
    const { headerHeight } = useOutletContext();
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const dispatch = useDispatch();
    const { showDialog } = useDialog();
    const {
      bookings,
      LastBookingsFromAPI,
      deleteAPis,
      isScheduledBooking,
      showBookings,
      irisSearchId,
      irisEnrolleId,
    } = useSelector((state) => state?.bookings);
    const { configModules } = useSelector((state) => state?.config);
    const { isLoading: userDetailLoading, isSearchFilterActionTriggered } =
      useSelector((state) => state?.userDetail);

    const nextBtnRef = useRef();
    const tabChangeRef = useRef();
    const cancelTokenSourceRef = useRef(null);

    const [saveVisible, setSaveVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    // Lazily read here (synchronously, on the very first render) rather
    // than set later from a useEffect - showBookings/bookings are shared
    // redux flags this page doesn't own exclusively (Staff/Warrants/
    // Transport/Visitor Log all use the same ones), so on a *second* open
    // of this modal-embedded read-only view they can already be sitting at
    // "true"/some other module's data from a previous open, before this
    // instance's own mount effect has even run. Gating the render below on
    // this - computed before that stale showBookings value could ever be
    // read - means it doesn't matter what showBookings/bookings already
    // are; the wrong content never gets a chance to render even once.
    const [isLinkedBookingLoading, setIsLinkedBookingLoading] = useState(
      () => isNonEmptyVariable(sessionStorage.getItem("open-booking-number")),
    );
    const [searchTxt, setSearchTxt] = useState("");
    const [user, setUser] = useState(null);
    const [reportListLoading, setReportListLoading] = useState(false);
    const [reportListData, setReportListData] = useState([]);
    const [filteredReportListData, setFilteredReportListData] = useState([]);

    // Config button (reorder/resize columns) for the main Bookings search
    // grid, rendered inside <ReportList> — see the comment above
    // REPORT_LIST_HEADERS in ReportList.jsx for why this hook lives here
    // rather than inside that shared component (it used to, but the Config
    // *button* had nowhere to render there, so it silently never appeared).
    // gridId matches legacy ListID "Bookings" (BookingsSummaryInterface.asp,
    // GetModuleName = "Bookings Summary") and is intentionally shared with
    // Inmate Movement's own call to this same hook, for the same grid.
    const {
      headers: reportListHeaders,
      isConfiguring,
      configButtonLabel,
      startConfiguring,
      confirmSave,
      discardChanges,
      dataTableRef,
    } = useGridColumnConfig("Bookings Summary:Bookings", REPORT_LIST_HEADERS);

    const [showFilter, setShowFilter] = useState(false);
    const [reportListTotal, setReportListTotal] = useState();
    const [isFiltered, setIsFiltered] = useState(false);
    const [bookingSearchPayload, setBookingSearchPayload] = useState([
      { filterKey: "searchType", value: "Starts With" }, // { filterKey: "custodyStatus", value: "In Custody" },
    ]);
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: 100,
    });
    const [tablePagination, setTablePagination] = useState({
      pageIndex: 0,
      pageSize: 100,
    });
    const [isDeleting, setIsDeleting] = useState(false);
    const navigate = useNavigate();
    const [isShowTracking, setisShowTracking] = useState(false);
    const houseFormRef = useRef();
    const [isLoadingHT, setisLoadingHT] = useState(false);
    const fullSearch = useSelector((state) => state.fullSearch);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [currentTabKey, setCurrentTabKey] = useState(null);
    const [irisHistoryLoading, setIrisHistoryLoading] = useState(false);
    const [irisHistoryData, setIrisHistoryData] = useState();
    const [irisHistoryPopupOpen, setIrisHistoryPopupOpen] = useState(false);

    const [sortInfo, setSortInfo] = useState({
      orderBy: null,
      direction: "DESC",
    });
    const isPageRef = useRef(false);

    const allFormRef = {
      personalFormRef: useRef(),
      personalFormAliasesRef: useRef(),
      personalFormPlaceOfBirthRef: useRef(),
      personalFormDistinguishingRef: useRef(),
      arrestbookFormRef: useRef(),
      bookingInfoFormRef: useRef(),
      scheduledBookingRef: useRef(),
      bookingChargeRef: useRef(),
      inmateInfoRef: useRef(),
      scheduledEventRef: useRef(),
      boookingsRelease: useRef(),
      bookingsCommentsRef: useRef(),
      folderFlagsRef: useRef(),
      classificationDetailsRef: useRef(),
      bookingsMovementRulesRef: useRef(),
      houseFormRef: useRef(),
      associatesDetailsRef: useRef(),
      bookingHoldsRef: useRef(),
      docsRef: useRef(),
      signaturesRef: useRef(),
      victimNotificationDetailsRef: useRef(),
      billingDetailsRef: useRef(),
      visitorLogDetailsRef: useRef(),
      jailIncidentsDetailsRef: useRef(),
      bookingQueueDetailsRef: useRef(),
      releaseQueueDetailsRef: useRef(),
      medicalRef: useRef(),
      inmateMedicationsDetailsRef: useRef(),
      medicalAuthorizationsDetailsRef: useRef(),
      appointmentLogDetailsRef: useRef(),
      propertyRef: useRef(),
      propertyListRef: useRef(),
      OfficerReportsDetailsRef: useRef(),
      bookingAdministrativeInformationRef: useRef(),
    };

    const DropdownButtonItem = [
      {
        label: "Scheduled Booking",
        key: "scheduledBooking",
      },
    ];

    // const [results, setResults] = useState([]);
    const [isFindModalVisible, setIsFindModalVisible] = useState(false);
    // const [isReportModalVisible, setIsReportModalVisible] = useState(false);
    const {
      setIsReportModalVisible,
      setResults,
      results: irisScanResults,
    } = useContext(ReportModalContext);

    useEffect(() => {
      if (isScheduledBooking && bookings === null) {
        dispatch(setIsScheduledBooking(false));
      }
      const loginUser = JSON.parse(localStorage.getItem("userDetails"));
      if (isNonEmptyVariable(loginUser)) {
        setUser(loginUser);
      }

      // Opened from another module's "view this booking" action (e.g. Visitor
      // Log's Inmate Details "..." button) - mirrors ASP's SFLOSupport.vbs
      // "..." button (prvSFLO_SubObjectDetails / SubObjectDetails), which
      // shows the linked Booking read-only, not in Modify mode.
      // bookingsFieldsEnabled defaults to false, so this lands read-only.
      const openBookingNumber = sessionStorage.getItem("open-booking-number");
      if (isNonEmptyVariable(openBookingNumber)) {
        sessionStorage.removeItem("open-booking-number");
        // Set up front rather than relying on the separate [showBookings]
        // effect elsewhere to set this once showBookings flips true -
        // BookingsDetails should only ever mount (below, once
        // isLinkedBookingLoading clears) with a valid tab already selected.
        setCurrentTabKey("personal-information");
        handleSelectBookingNumber(openBookingNumber).finally(() =>
          setIsLinkedBookingLoading(false),
        );
      } else if (!isBQ) {
        const fj = sessionStorage.getItem("from-jacket");
        if (
          !isNonEmptyVariable(fj) ||
          (isNonEmptyVariable(fj) && fj == "false")
        ) {
          dispatch(setBookings(LastBookingsFromAPI));
          // getLatestBookings();
        }

        if (isNonEmptyVariable(fj) && fj == "true") {
          setSaveVisible(true);
          dispatch(setShowBookings(true));
        } else {
          setSaveVisible(false);
        }
      }
      return () => {
        dispatch(setFullSearch(false));
        if (!!!fromFolderDetails) dispatch(setShowBookings(false));
        // dispatch(setBookingsNull());
        // dispatch(setBookingsFieldsEnabled(false));
      };
    }, []);

    useEffect(() => {
      setCurrentTabKey("personal-information");
    }, [showBookings]);

    useEffect(() => {
      if (!isBQ && !showFilter) {
        getReportListData();
      }
    }, [tablePagination]);

    // Document Control's "Find" action (for the Bookings module) triggers the
    // same in-page filter modal as this page's own "Show Filter" button, so
    // results land in this page's report table instead of a separate popup.
    useEffect(() => {
      if (isBQ) return;
      if (
        isNonEmptyVariable(isSearchFilterActionTriggered) &&
        isSearchFilterActionTriggered
      ) {
        setShowFilter(true);
      }
    }, [isSearchFilterActionTriggered]);

    useEffect(() => {
      if (!showFilter && isSearchFilterActionTriggered) {
        dispatch(setisSearchFilterActionTriggered(false));
      }
    }, [showFilter]);

    // Document Control's "Search Iris" action already scans and calls the
    // irish endpoint itself — it just hands the matched rows back here via
    // ReportModalContext. Show them in this page's report table instead of
    // the popup DocumentControl used to open.
    useEffect(() => {
      if (isBQ || !irisScanResults) return;

      dispatch(setShowBookings(false));
      setFilteredReportListData(irisScanResults);
      setReportListTotal(irisScanResults.length);
      setIsFiltered(true);
      setResults(null);
    }, [irisScanResults]);

    useEffect(() => {
      if (isBQ) {
        dispatch(setShowBookings(true));
        modifyBookingsAction();
        if (isNonEmptyVariable(nextBookingStep)) {
          if (nextBookingStep?.key === "medical-questionnaires") {
            setTimeout(() => {
              tabChangeRef.current?.setSelectedGroup("inmate-medical");
              setTimeout(() => {
                tabChangeRef.current?.onTabChange(nextBookingStep?.key);
              }, 600);
            }, 500);
          } else {
            setTimeout(() => {
              tabChangeRef.current?.setSelectedGroup("arrest-report");
              setTimeout(() => {
                tabChangeRef.current?.onTabChange(nextBookingStep?.key);
              }, 600);
            }, 500);
          }

          const bookingNumber = isNonEmptyVariable(
            nextBookingStep?.value?.booking,
          )
            ? nextBookingStep?.value?.booking
            : "";
          if (isNonEmptyVariable(bookingNumber)) {
            onSearch(bookingNumber);
          }
        }
      }
    }, [isBQ]);

    const location = useLocation();
    const { module } = location.state || {};

    useEffect(() => {
      console.log("bookings", bookings);
      const scheduledBooking =
        bookings?.bookingId && bookings?.arrestReports?.[0]?.scheduledBooking;
      if (
        scheduledBooking &&
        bookings?.arrestReports?.[0]?.scheduledBookingCleared !== true
      ) {
        dispatch(setIsScheduledBooking(true));
      } else if (
        bookings?.bookingId &&
        !(
          bookings?.arrestReports?.[0]?.scheduledBooking === true &&
          bookings?.arrestReports?.[0]?.scheduledBookingCleared === true
        )
      ) {
        dispatch(setIsScheduledBooking(false));
      }
    }, [bookings]);

    useEffect(() => {
      if (!location?.state?.refresh) return;

      setBookingSearchPayload([
        { filterKey: "searchType", value: "Starts With" },
      ]);
      setIsFiltered(false);

      setReportListData([]);
      setReportListTotal(0);

      setPagination({
        pageIndex: 0,
        pageSize: 100,
      });

      dispatch(setFullSearch(false));
      dispatch(setShowBookings(false));
      setTablePagination({
        pageIndex: 0,
        pageSize: 100,
      });
    }, [location.state?.refresh]);

    const onNextClickTrigger = () => {
      nextBtnRef?.current?.onNextClick();
    };

    const modifyBookingsAction = () => {
      setSaveVisible(true);
      dispatch(setBookingsFieldsEnabled(true));
    };

    const newBookingsAction = (e, scheduledBooking = false) => {
      if (cancelTokenSourceRef.current) {
        cancelTokenSourceRef.current.cancel("new booking.");
      }
      sessionStorage.setItem("jacket-before", MODULES_LIST?.BOOKINGS);
      dispatch(setIsScheduledBooking(scheduledBooking));
      setIsLoading(() => false);
      navigate(ROUTES_PATH?.JACKET_SEARCH);
      // if (module !== "arrest-report") {
      //   showDialog("info", {
      //     title: "Warning",
      //     content: `You can only create new records when you are in the Arrest Report submodule.`,
      //     confirmButtonText: "Ok",
      //   });
      //   return;
      // }
      // setSaveVisible(true);
      dispatch(setBookingsNull());
    };

    const cancelBookingsAction = () => {
      setSaveVisible(false);
      setSearchTxt("");
      setIsLoading(() => false);
      // Reverting bookings below only pushes fresh *values* into the Personal
      // Info form (via its own setFieldsValue effect) - antd doesn't clear a
      // field's validation error just because its value was set
      // programmatically, so a message like the Home Phone format error
      // would otherwise keep showing even after the invalid text is gone.
      // resetForm() clears both; the redux update that follows immediately
      // repopulates the reverted values.
      allFormRef?.personalFormRef?.current?.resetForm();
      dispatch(setBookings(LastBookingsFromAPI));
      dispatch(setBookingsFieldsEnabled(false));
      dispatch(setIsScheduledBooking(false));
      dispatch(setIrisSearchId(0));
      dispatch(setIrisEnrolleId(0));
      dispatch(setFullSearch(false));
    };

    const preRebook = () => {
      let validations = [Promise.resolve(true)];
      validations = [
        allFormRef?.personalFormRef?.current?.validateFields(),
        allFormRef?.personalFormAliasesRef?.current?.validateFields(),
        allFormRef?.personalFormPlaceOfBirthRef?.current?.validateFields(),
      ];
      Promise.all(validations)
        .then(() => {
          if (allFormRef?.personalFormRef?.current?.hasUnverifiedFields?.()) {
            notificationService.error(
              "You must verify all fields copied from the existing folder before saving.",
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("personal-information");
            }, 0);
            return;
          }

          if (
            !isNonEmptyVariable(bookings?.arrestReports?.[0]?.agency) ||
            !isNonEmptyVariable(bookings?.arrestReports?.[0]?.arrestCity)
          ) {
            notificationService.error(
              "Validation Error",
              `Please fill arrest information mandatory fields`,
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("arrest-information");
              allFormRef?.arrestbookFormRef?.current?.validateFields();
            }, 0);

            return;
          }
          setisShowTracking(() => true);
        })
        .catch((err) => {
          let tabToChange = "personal-information";
          let requiredField = err?.errorFields[0]?.name[0];

          if (requiredField) {
            tabToChange =
              Object.keys(mandatoryFields).find((tab) =>
                mandatoryFields[tab].includes(requiredField),
              ) || "personal-information";
          }

          notificationService.error(
            "Validation Error",
            `Fill all mandatory fields in ${tabToChange
              .split("-")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}`,
          );

          setTimeout(() => {
            tabChangeRef.current?.onTabChange(tabToChange);
            // Move focus to the first error element
            setTimeout(() => {
              const firstErrorField = document.querySelector(
                `#${requiredField}`,
              );

              firstErrorField?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              firstErrorField?.focus();
            }, 300);
          }, 0);
        });
    };

    const handleSave = () => {
      houseFormRef?.current?.validateFields().then((values) => {
        const ht = {
          ...values,
          actualDate: isNonEmptyVariable(values?.actualDateTime)
            ? dayjs(values?.actualDateTime)?.format("MM/DD/YYYY")
            : null,
          actualTime: isNonEmptyVariable(values?.actualDateTime)
            ? dayjs(values?.actualDateTime)?.format("HH:mm")
            : null,
          expectedBackDate: isNonEmptyVariable(values?.expectedBackDateTime)
            ? dayjs(values?.expectedBackDateTime)?.format("MM/DD/YYYY")
            : null,
          expectedBackTime: isNonEmptyVariable(values?.expectedBackDateTime)
            ? dayjs(values?.expectedBackDateTime)?.format("HH:mm")
            : null,
          returnDate: isNonEmptyVariable(values?.returnBackDateTime)
            ? dayjs(values?.returnBackDateTime)?.format("MM/DD/YYYY")
            : null,
          returnTime: isNonEmptyVariable(values?.returnBackDateTime)
            ? dayjs(values?.returnBackDateTime)?.format("HH:mm")
            : null,
          scheduledDate: isNonEmptyVariable(values?.scheduleDateTime)
            ? dayjs(values?.scheduleDateTime)?.format("MM/DD/YYYY")
            : null,
          scheduledTime: isNonEmptyVariable(values?.scheduleDateTime)
            ? dayjs(values?.scheduleDateTime)?.format("HH:mm")
            : null,
        };

        delete ht?.returnBackDateTime;
        delete ht?.expectedBackDateTime;
        delete ht?.scheduleDateTime;
        delete ht?.actualDateTime;

        const newInvolvement = {
          invCreatedBy: user?.staffId,
          invObjType: 3,
          invObjId: bookings.bookingId,
          invCreatedDate: dayjs().format("MM/DD/YYYY HH:mm:ss"),
          linkedObjectType: "Folders",
          relatedObjectType: "Bookings",
          flagTypeID: REF_LIST_CODE.FLAG_TYPE.INJAIL,
        };

        const b = _.cloneDeep(bookings);
        b?.inmateTracking?.push(ht);
        b?.cdInvolvements?.push(newInvolvement);

        setisLoadingHT(() => true);

        preSaveBookingAction(null, "rebook", b);
      });
    };

    const fullSearchAction = async () => {
      const fullSearchPayload = deepReplaceEmptyWithNull(bookings);
      try {
        setIsLoading(() => true);
        const response = await api.post(
          API_ENDPOINTS.bookingsFullSearch + "?size=500&direction=desc",
          fullSearchPayload,
        );

        const data = response?.data;
        setIsLoading(() => false);
        if (!data?.rows?.length) {
          notificationService.error(
            "No records found for the given search criteria",
          );
        } else {
          // Don't open the BI2 Technologies Report modal here - setting
          // `results` below is already picked up by the irisScanResults
          // effect above, which renders this page's own report table and
          // then clears `results` back to null. That clear races the modal
          // (DocumentControl/index.jsx), which reads `results` live off the
          // same ReportModalContext - the modal would flash open with the
          // right rows and then immediately flip to "No records found." as
          // soon as the effect's cleanup ran. The inline table is unaffected
          // since it copies the rows into its own local state first.
          setResults(data?.rows);
          setIsFindModalVisible(false);
        }
      } catch (error) {
        console.error("Full Search Error:", error);
      }
    };

    const preSaveBookingAction = (e, action = "save", payload = null) => {
      // Handle the rebook flow for scheduled booking
      if (action === "rebook" && !payload?.inmateTracking?.length) {
        notificationService.error(
          "You must have complete move status in house & track",
        );
        tabChangeRef.current?.setSelectedGroup("arrest-report");
        setTimeout(() => {
          tabChangeRef.current?.onTabChange("housing-tracking");
        }, 0);

        dispatch(
          setBookings({
            arrestReports: [
              {
                ...bookings?.arrestReports?.[0],
                scheduledBookingCleared: true,
                scheduledBookingClearanceReasonId: 54600006,
              },
            ],
          }),
        );
        dispatch(setIsScheduledBooking(false));
      }
      let validations = [Promise.resolve(true)];
      if (
        (isScheduledBooking ||
          bookings?.arrestReports?.[0]?.scheduledBooking) &&
        action === "save" &&
        bookings?.arrestReports?.[0]?.scheduledBookingCleared !== true
      ) {
        validations = [
          allFormRef?.scheduledBookingRef?.current?.validateFields(),
        ];
      } else if (
        (!isBQ &&
          (!isScheduledBooking ||
            bookings?.arrestReports?.[0]?.scheduledBookingCleared === true)) ||
        action === "rebook"
      ) {
        validations = [
          allFormRef?.personalFormRef?.current?.validateFields(),
          allFormRef?.personalFormAliasesRef?.current?.validateFields(),
          allFormRef?.personalFormPlaceOfBirthRef?.current?.validateFields(),
          // allFormRef?.personalFormDistinguishingRef?.current?.validateFields(),
          allFormRef?.arrestbookFormRef?.current?.validateFields(),
          // allFormRef?.inmateInfoRef?.current?.validateFields(),
          // allFormRef?.propertyRef?.current?.validateFields(),
        ];
      }

      if (bookings?.arrestReports?.[0]?.scheduledBookingCleared === true) {
        if (
          bookings?.arrestReports?.[0]?.scheduledBookingAgency?.toLowerCase() ===
          "jail"
        ) {
          if (
            bookings?.arrestReports?.[0]?.scheduledBookingClearanceReasonId !==
            54600006
          ) {
            let tabToChange = Object.keys(mandatoryFields).find((tab) =>
              mandatoryFields[tab].includes(
                "scheduledBookingClearanceReasonId",
              ),
            );
            setTimeout(() => {
              tabChangeRef.current?.onTabChange(tabToChange);
              const firstErrorField =
                document.querySelector(`#clearanceReason`);

              firstErrorField?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              firstErrorField?.focus();
            }, 0);

            showDialog("info", {
              title: "Warning",
              content: `Invalid clearance reason. If the inmate is in custody, the Scheduled Booking Clearance Reason should be 'Incarcerated'`,
              confirmButtonText: "Ok",
            });
            return;
          }
        }
      }

      if (action === "rebook") {
        const currentDateTime = dayjs().format("MM/DD/YYYY HH:mm");
        payload = {
          ...payload,
          isNeedToSubmitGenericInterface: true,
          arrestReports: [
            {
              ...payload?.arrestReports?.[0],
              incarcerationDate: currentDateTime.split(" ")[0],
              incarcerationTime: currentDateTime.split(" ")[1],
              releaseDate: null,
              releaseTime: null,
              releaseReasonId: null,
              releaseOfficerStaffId: null,
            },
          ],
        };
      }

      Promise.all(validations)
        .then(() => {
          if (allFormRef?.personalFormRef?.current?.hasUnverifiedFields?.()) {
            notificationService.error(
              "You must verify all fields copied from the existing folder before saving.",
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("personal-information");
            }, 0);
            return;
          }

          if (!isScheduledBooking && !isBQ)
            if (
              !isNonEmptyVariable(bookings?.arrestReports?.[0]?.agency) ||
              !isNonEmptyVariable(bookings?.arrestReports?.[0]?.arrestCity)
            ) {
              notificationService.error(
                "Validation Error",
                `Please fill arrest information mandatory fields`,
              );
              tabChangeRef.current?.setSelectedGroup("arrest-report");
              setTimeout(() => {
                tabChangeRef.current?.onTabChange("arrest-information");
                allFormRef?.arrestbookFormRef?.current?.validateFields();
              }, 0);

              return;
            }

          if (!bookings?.charges?.length && !isScheduledBooking && !isBQ) {
            notificationService.error("Validation Error", `Please add Charges`);
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("charges");
            }, 0);
            return;
          }

          if (
            !isScheduledBooking &&
            !bookings?.inmateTracking?.length &&
            !isBQ
          ) {
            notificationService.error(
              "You must have complete move status in house & track",
            );
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("housing-tracking");
            }, 0);
            return;
          }

          if (
            !isScheduledBooking &&
            bookings?.inmateTracking?.length > 0 &&
            !isBQ
          ) {
            const hasLoanOrJailCompleted = bookings?.inmateTracking?.some(
              (item) =>
                (item?.inmateLocation?.toLowerCase() === "loan" ||
                  item?.inmateLocation?.toLowerCase() === "in jail") &&
                item?.movementStatus?.toLowerCase() === "complete",
            );
            const haspermhouseOrtransportCompleted =
              bookings?.inmateTracking?.some(
                (item) =>
                  (item?.inmateLocation?.toLowerCase() ===
                    "perm housing change" ||
                    item?.inmateLocation?.toLowerCase() === "transport") &&
                  item?.movementStatus?.toLowerCase() === "complete",
              );
            if (haspermhouseOrtransportCompleted && !hasLoanOrJailCompleted) {
              notificationService.error(
                "You must save the Booking record at least once before you can Transport the inmate",
              );
              tabChangeRef.current?.setSelectedGroup("arrest-report");
              setTimeout(() => {
                tabChangeRef.current?.onTabChange("housing-tracking");
              }, 0);
              return;
            }
            if (!hasLoanOrJailCompleted) {
              notificationService.error(
                "You must have atleast one complete move status in house & track",
              );
              tabChangeRef.current?.setSelectedGroup("arrest-report");
              setTimeout(() => {
                tabChangeRef.current?.onTabChange("housing-tracking");
              }, 0);
              return;
            }
          }
          // Yoges - Commented this code because when creating a new bookings then charges also mandatory
          // if (isNonEmptyVariable(bookings?.bookingNumber)) {
          //   if (!bookings?.charges?.length && !isScheduledBooking && !isBQ) {
          //     notificationService.error("Validation Error", `Please add Charges`);
          //     tabChangeRef.current?.setSelectedGroup("arrest-report");
          //     setTimeout(() => {
          //       tabChangeRef.current?.onTabChange("charges");
          //     }, 0);

          //     return;
          //   }
          // }
          if (isNonEmptyVariable(payload)) {
            saveBookingsAction(action, payload);
          } else {
            const data = _.cloneDeep(bookings);
            saveBookingsAction(action, data);
          }
        })
        .catch((err) => {
          let tabToChange = "personal-information";
          let requiredField = err?.errorFields[0]?.name[0];

          if (requiredField) {
            tabToChange =
              Object.keys(mandatoryFields).find((tab) =>
                mandatoryFields[tab].includes(requiredField),
              ) || "personal-information";
          }

          notificationService.error(
            "Validation Error",
            `Fill all mandatory fields in ${tabToChange
              .split("-")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}`,
          );

          if (tabToChange === "property-taken-inmate") {
            tabChangeRef.current?.setSelectedGroup("inmate-property");
          } else {
            tabChangeRef.current?.setSelectedGroup("arrest-report");
          }

          setTimeout(() => {
            tabChangeRef.current?.onTabChange(tabToChange);
            // Move focus to the first error element
            setTimeout(() => {
              const firstErrorField = document.querySelector(
                `#${requiredField}`,
              );

              firstErrorField?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              firstErrorField?.focus();
            }, 300);
          }, 0);
        });
    };

    function cleanObject(obj) {
      if (Array.isArray(obj)) {
        // If it's an array, recursively clean each item and filter out empty values
        return obj
          .map(cleanObject) // Recursively clean each element
          .filter(
            (value) =>
              value !== undefined &&
              value !== null &&
              value !== "" &&
              (Array.isArray(value) ? value.length > 0 : true) &&
              (typeof value === "object"
                ? Object.keys(value).length > 0
                : true),
          );
      } else if (typeof obj === "object" && obj !== null) {
        // If it's an object, recursively clean its properties
        return Object.entries(obj).reduce((acc, [key, value]) => {
          const cleanedValue = cleanObject(value); // Recursively clean the value
          if (
            cleanedValue !== undefined &&
            cleanedValue !== null &&
            cleanedValue !== "" &&
            (typeof cleanedValue === "object"
              ? Object.keys(cleanedValue).length > 0
              : true)
          ) {
            acc[key] = cleanedValue; // Add only non-empty values
          }
          return acc;
        }, {});
      }
      // If it's a primitive value, return it as-is
      return obj;
    }

    const saveBookingsAction = async (action, data) => {
      const payload = data;
      delete payload?.genericInterfaceSubmission;
      delete payload?.visitorLogBooking;

      // Snapshot the locally-edited extra rows before the save/refresh cycle
      // below replaces `bookings` with the server's response (which won't
      // include these separately-persisted extra tables).
      const bioExtraSnapshot = bookings?.bio?.[0]?.bioExtra?.[0];
      const arrestReportsExtraSnapshot =
        bookings?.arrestReports?.[0]?.arrestReportsExtra?.[0];
      const inmatePropertyExtraSnapshot =
        bookings?.inmateProperty?.[0]?.inmatePropertyExtra?.[0];
      const inmateMedicalExtraSnapshot =
        bookings?.inmateMedical?.[0]?.inmateMedicalExtra?.[0];
      const cashAccountingNewExtraSnapshot =
        bookings?.bookingCashAccount?.[0]?.cashAccountingNew?.[0]
          ?.cashAccountingNewExtra?.[0];
      // Same idea, for each transaction's cashAccountingNewTransactionsExtra[0].
      const cashAccountingNewTransactionsSnapshot =
        bookings?.bookingCashAccount?.[0]?.cashAccountingNew?.[0]
          ?.cashAccountingNewTransactions;
      // Same idea, for each medication's medicationLog[].medicationLogExtra[0].
      const medicationsSnapshot = bookings?.medications;
      // Same idea, for each victim notification's victimNotificationExtra[0].
      const victimNotificationsSnapshot = bookings?.victimNotifications;
      // A booking can have several bail records, each with its own
      // bookingBailsExtra[0] — saveBookingBailsExtra always resolves these
      // post-refresh (matching new ones by bookingBailUuid), so the whole
      // pre/post-save-known-id split above doesn't apply to it.
      const bookingBailsSnapshot = bookings?.bookingBails;
      // A booking can have several holds, each with its own holdsExtra[0] —
      // unlike bookingBailsSnapshot, only holds that already had a real
      // holdID before this save get resolved (see saveHoldsExtra).
      const holdsSnapshot = bookings?.holds;
      // Same idea, for Movement Rules' inmateMovementRulesExtra[0].
      const movementRulesSnapshot = bookings?.inmateMovementRule;
      // Same idea, for Housing and Tracking's inmateTrackingExtra[0].
      const inmateTrackingSnapshot = bookings?.inmateTracking;
      // Same idea, for each Property List item's inmatePropertyItemsExtra[0].
      const inmatePropertyItemsSnapshot =
        bookings?.inmateProperty?.[0]?.inmatePropertyItems;
      // Same idea, for each Appointment Log entry's appointmentLogExtra[0].
      const appointmentLogSnapshot = bookings?.appointmentLog;
      // Same idea, for each Bio address's addresses[0].addressesExtra[0].
      const bioAddressesSnapshot = bookings?.bio?.[0]?.bioAddresses;
      // Same idea, for a Job Schedule scheduled event's business's
      // businessesExtra[0].
      const scheduledEventsSnapshot = bookings?.scheduledEvents;

      // // To set controll agency case number, ori id and inmate status id if not set.
      // if (!isNonEmptyVariable(payload?.arrestReports?.[0]?.controllingAgencyCaseNumber) &&
      //   !isNonEmptyVariable(payload?.arrestReports?.[0]?.controllingAgencyOriId) &&
      //   !isNonEmptyVariable(payload?.arrestReports?.[0]?.inmateStatusId)
      // ) {
      //   payload.arrestReports[0].inmateStatusId = "52119001"; // Default to In Custody if not set
      //   const controllingCharge = payload?.charges?.find(
      //     (charge) => charge.controllingCharge
      //   );
      //   if (isNonEmptyVariable(controllingCharge)) {
      //     payload.arrestReports[0].controllingAgencyCaseNumber =
      //       controllingCharge.caseNumber || "";
      //     payload.arrestReports[0].controllingAgencyOriId =
      //       controllingCharge.controllingAgencyORIID || "";
      //   }
      // }

      // ✅ Ensure arrestReports exists and has at least one element
      if (
        !Array.isArray(payload?.arrestReports) ||
        payload.arrestReports.length === 0
      ) {
        payload.arrestReports = [{}]; // initialize safely
      }

      const firstReport = payload.arrestReports[0];

      // ✅ Set controlling agency info and inmate status if missing
      if (
        !isNonEmptyVariable(firstReport?.controllingAgencyCaseNumber) &&
        !isNonEmptyVariable(firstReport?.controllingAgencyOriId) &&
        !isNonEmptyVariable(firstReport?.inmateStatusId)
      ) {
        const controllingCharge = payload?.charges?.find(
          (charge) => charge.controllingCharge,
        );

        if (isNonEmptyVariable(controllingCharge)) {
          firstReport.controllingAgencyCaseNumber =
            controllingCharge.caseNumber || "";
          firstReport.controllingAgencyOriId =
            controllingCharge.controllingAgencyORIID || "";
        }
      }

      if (
        !isNonEmptyVariable(
          payload?.arrestReports?.[0]?.classificationEffectiveDate,
        ) &&
        !isNonEmptyVariable(payload?.arrestReports?.[0]?.classificationId)
      ) {
        payload.arrestReports[0].classificationId = 154550003; // Default to Minimum
        payload.arrestReports[0].classificationEffectiveDate =
          dayjs().format("MM/DD/YYYY");
      }

      const preFinalPayload = cleanObject(payload);

      // handle the scheduled booking
      if (isScheduledBooking) {
        const hasScheduledBookingDate =
          payload?.arrestReports?.[0]?.scheduledBooking;
        if (!hasScheduledBookingDate) {
          showDialog("info", {
            title: "Warning",
            content: "Please fill the Scheduled Booking Information",
            confirmButtonText: "Ok",
          });
          tabChangeRef.current?.setSelectedGroup("arrest-report");
          setTimeout(() => {
            tabChangeRef.current?.onTabChange("scheduled-booking-information");
          }, 0);
          return;
        }
      }

      if (
        isNonEmptyVariable(payload?.arrestReports?.[0].incarcerationDate) &&
        isNonEmptyVariable(payload?.arrestReports?.[0].scheduledReleaseDate)
      ) {
        dayjs.extend(isSameOrAfter);
        const incarcerationDate = dayjs(
          payload?.arrestReports?.[0]?.incarcerationDate,
        );
        const scheduledReleaseDate = dayjs(
          payload?.arrestReports?.[0]?.scheduledReleaseDate,
        );
        if (!scheduledReleaseDate?.isSameOrAfter(incarcerationDate)) {
          showDialog("info", {
            title: "Warning",
            content: `The Scheduled Release Date must be on or after the Incarceration Date for the active Detention (${incarcerationDate})`,
            confirmButtonText: "Ok",
          });
          return;
        }
      }

      if (
        preFinalPayload?.inmateProperty?.[0]?.propertyReleased &&
        (!preFinalPayload?.inmateProperty?.[0]?.releasedTo ||
          !preFinalPayload?.inmateProperty?.[0]?.dateReleased ||
          !preFinalPayload?.inmateProperty?.[0]?.releasedByStaffId)
      ) {
        tabChangeRef.current?.setSelectedGroup("inmate-property");
        setTimeout(() => {
          tabChangeRef.current?.onTabChange("property-taken-inmate");
        }, 100);
        setTimeout(() => {
          allFormRef?.propertyRef?.current?.validateFields();
        }, 300);
        return;
      }

      // if (preFinalPayload.inJail === false) {
      //   preFinalPayload.arrestReports[0].releaseDate = null;
      //   preFinalPayload.arrestReports[0].releaseTime = null;
      //   preFinalPayload.arrestReports[0].releaseReasonId = null;
      //   preFinalPayload.arrestReports[0].holdReasonId ??= 154530006;
      //   // preFinalPayload.inmateTracking?.push({
      //   //   inmateTrackingID: null,
      //   //   inmateLocation: "In Jail",
      //   //   movementStatus: "Complete",
      //   // });
      // }

      const agency = user?.staff?.organization?.[0]?.agency;
      // return;
      const finalPayload = {
        bookings: {
          ...preFinalPayload,
          // Strips flagLabel/summaryDescription/relatedRecordSummary/deletable -
          // display-only fields mergeFlagsIntoInvolvements stamps onto flags
          // for the UI, not part of the write DTO.
          // Also drops root copies of questionnaire-owned flags (see
          // excludeQuestionnaireInvolvements) - those carry no sub-type, and
          // re-sending them wiped the saved medicalTypeId/dangerTypeId/etc.
          cdInvolvements: sanitizeInvolvementsForSave(
            excludeQuestionnaireInvolvements(
              preFinalPayload?.cdInvolvements,
              bookings,
            ),
          ),
          creatorStaffId: userDetails?.staffId,
          inJail: isScheduledBooking
            ? false
            : isNonEmptyVariable(preFinalPayload?.inJail) && action === "save"
              ? preFinalPayload?.inJail
              : true,
          user: userDetails?.username,
          transactionId: irisSearchId || 0,
          jackets: [
            {
              ...((preFinalPayload?.jackets && preFinalPayload.jackets[0]) ||
                {}),
              // New booking only: stamp the jacket with the current date/time.
              ...(!isNonEmptyVariable(preFinalPayload?.bookingId) && {
                masterTransactionDate: dayjs().format("MM/DD/YYYY HH:mm:ss"),
              }),
              staffJacket: false,
              orphanFlag: false,
            },
          ],
          arrestReports: [
            {
              ...((preFinalPayload?.arrestReports &&
                preFinalPayload.arrestReports[0]) ||
                {}),
              housingAgency: agency,
              custodialAgency: agency,
              holdReasonId: isNonEmptyVariable(
                preFinalPayload?.arrestReports?.[0]?.holdReasonId,
              )
                ? preFinalPayload?.arrestReports?.[0]?.holdReasonId
                : 154530006,
              scheduledBookingAgency: agency?.toUpperCase(),
              totalDaysInCustody:
                bookings?.detentions?.length &&
                isNonEmptyVariable(
                  bookings?.detentions?.[bookings?.detentions?.length - 1]
                    ?.lengthOfStay,
                )
                  ? bookings?.detentions?.[bookings?.detentions?.length - 1]
                      ?.lengthOfStay
                  : 0,
            },
          ],
          bio: [
            {
              ...((preFinalPayload?.bio && preFinalPayload.bio[0]) || {}),
              enrolleeId:
                preFinalPayload.bio[0]?.enrolleeId || irisEnrolleId || null,
              bioPhotos:
                preFinalPayload?.bio[0]?.bioPhotos?.map((p) => {
                  return {
                    ...p,
                    lineupFlag: true,
                  };
                }) || [],
            },
          ],
        },
      };

      const currentDateTime = dayjs().format("MM/DD/YYYY HH:mm");
      finalPayload.bookings.arrestReports[0].incarcerationDate ??=
        currentDateTime.split(" ")[0];
      finalPayload.bookings.arrestReports[0].incarcerationTime ??=
        currentDateTime.split(" ")[1];

      if (
        !isNonEmptyVariable(finalPayload?.bookings?.bookingsQueue) ||
        !finalPayload?.bookings?.bookingsQueue?.length
      ) {
        finalPayload.bookings.bookingsQueue = [
          {
            creatorStaffId: 1,
          },
        ];
      } else {
      }

      if (
        finalPayload?.bookings?.charges?.length &&
        finalPayload?.bookings?.charges?.every((c) => c?.clearedToGo)
      ) {
        finalPayload.bookings.readyForRelease = true;
      } else {
        finalPayload.bookings.readyForRelease = false;
      }

      if (finalPayload?.bookings?.bookingSignature?.length) {
        const bsa = _.cloneDeep(finalPayload?.bookings?.bookingSignature);
        finalPayload.bookings.bookingSignature = bsa?.map((bs) => {
          if (
            !bs?.signature?.[0]?.photos?.[0]?.fullSizePath?.includes(
              "TempPhotos",
            )
          ) {
            delete bs?.signature?.[0]?.photos;
          }
          return bs;
        });
      }

      // Booking_queue
      // INTAKE
      if (
        !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === REF_LIST_CODE.BQ_STEPS.INTAKE,
        ) ||
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === REF_LIST_CODE.BQ_STEPS.BOOKING_COMPLETE,
        )
      ) {
        finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
          ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
            []),
          {
            queStepID: REF_LIST_CODE.BQ_STEPS.INTAKE, // For house & track
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      if (
        finalPayload?.bookings?.charges?.length &&
        !(
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
            (item) => item.queStepID === 155190012,
          ) ||
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
            (item) => item.queStepID === 155190002,
          )
        )
      ) {
        finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
          ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
            []),
          {
            queStepID: 155190012, // For charges
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      if (finalPayload?.bookings?.medicalQuestionnaires?.length) {
        const medicalDetails =
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails || [];
        // Note: intentionally NOT bypassed by an existing Booking Complete
        // (155190002) row - Booking Complete gets auto-stamped as soon as
        // charges + jacket exist, which happens well before Medical is
        // answered, so treating it as "already done" would permanently block
        // this step from ever being recorded.
        const medicalAlreadyDone = medicalDetails.some(
          (item) => item.queStepID === 155190003 && item.complete === true,
        );
        if (!medicalAlreadyDone) {
          const idx = medicalDetails.findIndex(
            (item) => item.queStepID === 155190003,
          );
          const medicalStepRow = {
            queStepID: 155190003, // For medical
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          };
          finalPayload.bookings.bookingsQueue[0].bookingQueueDetails =
            idx === -1
              ? [...medicalDetails, medicalStepRow]
              : medicalDetails.map((r, i) =>
                  i === idx ? { ...r, ...medicalStepRow } : r,
                );
        }
      }

      if (finalPayload?.bookings?.inmateClassificationQuestionnaires?.length) {
        const classificationDetails =
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails || [];
        // Same reasoning as Medical above: don't let a pre-existing Booking
        // Complete row permanently block this step from ever being recorded.
        const classificationAlreadyDone = classificationDetails.some(
          (item) => item.queStepID === 155190005 && item.complete === true,
        );
        if (!classificationAlreadyDone) {
          const idx = classificationDetails.findIndex(
            (item) => item.queStepID === 155190005,
          );
          const classificationStepRow = {
            queStepID: 155190005, // For classifications
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          };
          finalPayload.bookings.bookingsQueue[0].bookingQueueDetails =
            idx === -1
              ? [...classificationDetails, classificationStepRow]
              : classificationDetails.map((r, i) =>
                  i === idx ? { ...r, ...classificationStepRow } : r,
                );
        }
      }

      if (
        finalPayload?.bookings?.bookingsJacketsJackets?.length &&
        !(
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
            (item) => item.queStepID === 155190014,
          ) ||
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
            (item) => item.queStepID === 155190002,
          )
        )
      ) {
        finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
          ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
            []),
          {
            queStepID: 155190014, // For associates
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      if (
        finalPayload?.bookings?.bio?.[0]?.bioPhotos?.length &&
        !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190007,
        )
      ) {
        finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
          ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
            []),
          {
            queStepID: 155190007, // For mugshot
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      // HSG only completes when the inmate has actually been housed In Jail in
      // a Cell — any other movement (Loan, Transport, Holding, etc.) shouldn't
      // mark this step complete just because inmateTracking has entries.
      const isCellHousing = finalPayload?.bookings?.inmateTracking?.some(
        (t) =>
          t?.inmateLocation === "In Jail" &&
          t?.movementStatus === "Complete" &&
          t?.inJailType === "Cell",
      );
      if (
        isCellHousing &&
        !(
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
            (item) => item.queStepID === 155190011,
          ) ||
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
            (item) => item.queStepID === 155190002,
          )
        )
      ) {
        finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
          ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
            []),
          {
            queStepID: 155190011, // For house & track
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      // Only Danger, Gang, Medical, or Notes involvements count as a completed
      // Flags step — cdInvolvements also carries the auto-added "In Jail" entry
      // and Warrants/Civil Paper entries, none of which are an actual Folder
      // Flag the user set.
      const jacketFlagTypeIDs = [
        REF_LIST_CODE.FLAG_TYPE.DANGER,
        REF_LIST_CODE.FLAG_TYPE.GANG_MEMBER,
        REF_LIST_CODE.FLAG_TYPE.MEDICAL,
        REF_LIST_CODE.FLAG_TYPE.NOTES,
      ];
      if (
        // Includes flags nested inside each Classification questionnaire's
        // own cdInvolvement, not just the booking-root cdInvolvements array -
        // e.g. Classification's "Known gang affiliation?" -> Yes side effect
        // sets the Gang flag there now, not at root. See getAllInvolvements.
        getAllInvolvements(finalPayload?.bookings)?.some((inv) =>
          jacketFlagTypeIDs.includes(inv?.flagTypeID),
        ) &&
        !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190015,
        )
      ) {
        finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
          ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
            []),
          {
            queStepID: 155190015, // For jacket flag
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      if (
        finalPayload?.bookings?.victimNotifications?.length &&
        !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190016,
        )
      ) {
        finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
          ...(finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails ||
            []),
          {
            queStepID: 155190016, // For Victim notification
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      if (
        isNonEmptyVariable(
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails,
        ) &&
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails
          ?.length &&
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (x) => x?.queStepID === 155190013, // Remove From BQ
        )
      ) {
        if (
          finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
            (x) => x?.queStepID === 155190007, // MugSHOT
          )
        ) {
          // finalPayload.bookings.bookingsQueue =
          //   finalPayload?.bookings?.bookingsQueue?.map((bq) => {
          //     return {
          //       ...bq,
          //       complete: true,
          //     };
          //   });
        } else {
          showDialog("info", {
            title: "Warning",
            content: "You must have complete mugshot",
            confirmButtonText: "Ok",
          });
          return;
        }
      }

      if (
        finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails
          ?.length &&
        !finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails?.some(
          (item) => item.queStepID === 155190002,
        )
      ) {
        const booking = finalPayload?.bookings;
        if (isNonEmptyVariable(booking)) {
          if (
            booking?.charges?.length &&
            booking?.bookingsJacketsJackets?.length
          ) {
            finalPayload.bookings.bookingsQueue[0].bookingQueueDetails = [
              ...(finalPayload?.bookings?.bookingsQueue?.[0]
                ?.bookingQueueDetails || []),
              {
                queStepID: 155190002, // For Booking complete
                complete: true,
                completionDate: dayjs().format("MM/DD/YYYY"),
                completionTime: dayjs().format("HH:mm"),
                completionStaffID: userDetails?.staffId,
              },
            ];
          }
        }
      }

      finalPayload.bookings.bookingsQueue = [
        {
          bookingQueueDetails:
            finalPayload?.bookings?.bookingsQueue?.[0]?.bookingQueueDetails,
        },
      ];

      delete finalPayload?.bookings?.bookingQueueDetails;

      if (
        (!finalPayload?.bookings?.charges?.length ||
          finalPayload?.bookings?.charges?.every(
            (charge) => charge.clearedToGo === true,
          )) &&
        !finalPayload?.bookings?.releaseQueueDetails?.some(
          (item) => item.releaseQueStepID === 155400001,
        )
      ) {
        finalPayload.bookings.releaseQueueDetails = [
          ...(finalPayload?.bookings?.releaseQueueDetails || []),
          {
            releaseQueStepID: 155400001, // For charges cleared
            complete: true,
            completionDate: dayjs().format("MM/DD/YYYY"),
            completionTime: dayjs().format("HH:mm"),
            completionStaffID: userDetails?.staffId,
          },
        ];
      }

      if (
        ((finalPayload?.bookings?.inmateTracking?.length &&
          !finalPayload?.bookings?.inmateTracking?.some(
            (item) => item.movementStatus === "Complete",
          )) ||
          !finalPayload?.bookings?.inmateTracking?.length) &&
        !isScheduledBooking
      ) {
        showDialog("info", {
          title: "Warning",
          content:
            "You must have atleast one complete move status in house & track",
          onConfirm: () => {
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("housing-tracking");
            }, 0);
          },
        });
        return;
      }

      setIsLoading(() => true);
      if (deleteAPis?.length) {
        try {
          deleteAPis?.forEach((d) => {
            if (bookings?.bookingId)
              d = d + `?rootAppContextKeyFieldId=${bookings.bookingId}`;
            api.delete(d);
          });
        } catch (error) {
          notificationService.error("Error", "Error Deleting Booking Items");
          setIsLoading(() => false);
          return;
        }
      }
      let bkng = finalPayload?.bookings;
      if (bkng) {
        let arr_rep = bkng?.arrestReports;
        let inmt_mvnt = bkng?.inmateTracking;
        if (arr_rep && inmt_mvnt) {
          if (inmt_mvnt?.length) {
            const reversed = [...inmt_mvnt].reverse();
            const lastInJailComplete = reversed.find(
              (t) =>
                t?.movementStatus === "Complete" &&
                t?.inmateLocation === "In Jail",
            );
            if (lastInJailComplete) {
              const { bed, block, cell, inJailType, holdingCell } =
                lastInJailComplete;
              arr_rep[0].housingAssignmentBed = bed;
              arr_rep[0].housingAssignmentCell = cell;
              arr_rep[0].housingAssignmentBlock = block;
              arr_rep[0].housingAssignmentType = inJailType || null;
              arr_rep[0].housingAssignmentIsolation =
                inJailType === "Holding" ? holdingCell || null : null;
            } else {
              arr_rep[0].housingAssignmentBed = null;
              arr_rep[0].housingAssignmentCell = null;
              arr_rep[0].housingAssignmentBlock = null;
              arr_rep[0].housingAssignmentType = null;
              arr_rep[0].housingAssignmentIsolation = null;
            }
          }
        }
      }

      // Mirrors legacy BookingInmateMovementCommon.vbs's HandleInmateTrackingLoan: a Loan
      // movement linked to a recurring Scheduled Event that just became Complete/Cancelled
      // in this save gets its link broken and the next occurrence generated, riding along
      // in this same save (unlike Transport, the new movement is nested under
      // scheduledEvents[].inmateTracking, so no second round-trip is needed).
      if (finalPayload?.bookings) {
        // Reconcile scheduledEvents[].inmateTracking against the flat (authoritative)
        // inmateTracking array first - e.g. a Housing & Tracking status change to
        // Complete - before the recurring-chain check below decides whether to break
        // the link and generate the next occurrence.
        const syncedScheduledEvents = syncScheduledEventsInmateTracking(
          finalPayload.bookings,
        );
        if (syncedScheduledEvents !== finalPayload.bookings.scheduledEvents) {
          finalPayload.bookings.scheduledEvents = syncedScheduledEvents;
        }

        const patchedScheduledEvents = getRecurringChainScheduledEvents(
          finalPayload.bookings,
          LastBookingsFromAPI,
        );
        if (patchedScheduledEvents !== finalPayload.bookings.scheduledEvents) {
          finalPayload.bookings.scheduledEvents = patchedScheduledEvents;
        }

        // Same reconciliation, for charges[].court[].inmateTracking[0]'s nested copy.
        const syncedCharges = syncChargesCourtInmateTracking(
          finalPayload.bookings,
        );
        if (syncedCharges !== finalPayload.bookings.charges) {
          finalPayload.bookings.charges = syncedCharges;
        }
      }

      console.log("finalPayload", finalPayload);

      const pendingTransportTriggers = getNewTransportTriggeringEntries(
        finalPayload?.bookings?.inmateTracking,
      );

      // Known before the save even runs when editing an existing booking
      // (bio/arrestReports/inmateProperty already have their real ids) —
      // only a brand new booking has to wait for the post-save refresh below
      // to learn them.
      const bioIdKnownBeforeSave = Boolean(bookings?.bio?.[0]?.bioId);
      const arrestReportIdKnownBeforeSave = Boolean(
        bookings?.arrestReports?.[0]?.arrestReportId,
      );
      const inmatePropertyIdKnownBeforeSave = Boolean(
        bookings?.inmateProperty?.[0]?.inmatePropertyId,
      );
      const inmateMedicalIdKnownBeforeSave = Boolean(
        bookings?.inmateMedical?.[0]?.inmateMedicalId,
      );
      const cashAccountingIdKnownBeforeSave = Boolean(
        bookings?.bookingCashAccount?.[0]?.cashAccountingNew?.[0]
          ?.cashAccountingId,
      );
      const anyExtraIdKnownBeforeSave =
        bioIdKnownBeforeSave ||
        arrestReportIdKnownBeforeSave ||
        inmatePropertyIdKnownBeforeSave ||
        inmateMedicalIdKnownBeforeSave ||
        cashAccountingIdKnownBeforeSave;

      // These are called with separate API calls after the main booking save, so they don't need to be included in this payload.
      delete finalPayload.bookings.bio?.[0]?.bioExtra;
      delete finalPayload.bookings.arrestReports?.[0]?.arrestReportsExtra;
      delete finalPayload.bookings.inmateProperty?.[0]?.inmatePropertyExtra;
      delete finalPayload.bookings.inmateMedical?.[0]?.inmateMedicalExtra;
      delete finalPayload.bookings.bookingCashAccount?.[0]
        ?.cashAccountingNew?.[0]?.cashAccountingNewExtra;
      // cashAccountingNewTransactionsExtra is a list (one per transaction),
      // not a singleton, so it's stripped per-entry rather than with a
      // single delete — saved separately post-refresh by
      // saveCashAccountingNewTransactionsExtra below.
      if (
        Array.isArray(
          finalPayload.bookings.bookingCashAccount?.[0]?.cashAccountingNew?.[0]
            ?.cashAccountingNewTransactions,
        )
      ) {
        finalPayload.bookings.bookingCashAccount[0].cashAccountingNew[0].cashAccountingNewTransactions =
          finalPayload.bookings.bookingCashAccount[0].cashAccountingNew[0].cashAccountingNewTransactions.map(
            (t) => {
              const copy = { ...t };
              delete copy.cashAccountingNewTransactionsExtra;
              return copy;
            },
          );
      }
      // bookingBailsExtra/holdsExtra are lists (one per bail/hold), not
      // singletons, so they're stripped per-entry rather than with a single
      // delete — saved separately post-refresh/post-save by
      // saveBookingBailsExtra/saveHoldsExtra below.
      if (Array.isArray(finalPayload.bookings.bookingBails)) {
        finalPayload.bookings.bookingBails =
          finalPayload.bookings.bookingBails.map((b) => {
            const copy = { ...b };
            delete copy.bookingBailsExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.holds)) {
        finalPayload.bookings.holds = finalPayload.bookings.holds.map((h) => {
          const copy = { ...h };
          delete copy.holdsExtra;
          return copy;
        });
      }
      if (Array.isArray(finalPayload.bookings.inmateMovementRule)) {
        finalPayload.bookings.inmateMovementRule =
          finalPayload.bookings.inmateMovementRule.map((r) => {
            const copy = { ...r };
            delete copy.inmateMovementRulesExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.inmateTracking)) {
        finalPayload.bookings.inmateTracking =
          finalPayload.bookings.inmateTracking.map((t) => {
            const copy = { ...t };
            delete copy.inmateTrackingExtra;
            return copy;
          });
      }
      if (
        Array.isArray(
          finalPayload.bookings.inmateProperty?.[0]?.inmatePropertyItems,
        )
      ) {
        finalPayload.bookings.inmateProperty[0].inmatePropertyItems =
          finalPayload.bookings.inmateProperty[0].inmatePropertyItems.map(
            (i) => {
              const copy = { ...i };
              delete copy.inmatePropertyItemsExtra;
              return copy;
            },
          );
      }
      if (Array.isArray(finalPayload.bookings.appointmentLog)) {
        finalPayload.bookings.appointmentLog =
          finalPayload.bookings.appointmentLog.map((a) => {
            const copy = { ...a };
            delete copy.appointmentLogExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.medications)) {
        finalPayload.bookings.medications =
          finalPayload.bookings.medications.map((m) => {
            if (!Array.isArray(m?.medicationLog)) return m;
            return {
              ...m,
              medicationLog: m.medicationLog.map((l) => {
                const copy = { ...l };
                delete copy.medicationLogExtra;
                return copy;
              }),
            };
          });
      }
      if (Array.isArray(finalPayload.bookings.victimNotifications)) {
        finalPayload.bookings.victimNotifications =
          finalPayload.bookings.victimNotifications.map((v) => {
            const copy = { ...v };
            delete copy.victimNotificationExtra;
            if (Array.isArray(copy.victimNotificationLog)) {
              copy.victimNotificationLog = copy.victimNotificationLog.map(
                (l) => {
                  const logCopy = { ...l };
                  delete logCopy.victimNotificationLogExtra;
                  return logCopy;
                },
              );
            }
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.bio?.[0]?.bioAddresses)) {
        finalPayload.bookings.bio[0].bioAddresses =
          finalPayload.bookings.bio[0].bioAddresses.map((ba) => {
            if (!ba?.addresses?.[0]) return ba;
            const addrCopy = { ...ba.addresses[0] };
            delete addrCopy.addressesExtra;
            return { ...ba, addresses: [addrCopy] };
          });
      }
      if (Array.isArray(finalPayload.bookings.scheduledEvents)) {
        finalPayload.bookings.scheduledEvents =
          finalPayload.bookings.scheduledEvents.map((se) => {
            const seCopy = { ...se };
            delete seCopy.scheduledEventsExtra;
            const rec = seCopy?.scheduledEventsRecurring?.[0];
            const wrd = rec?.workReleaseDestinations?.[0];
            const biz = wrd?.businesses?.[0];
            if (!biz?.businessesExtra) return seCopy;
            const bizCopy = { ...biz };
            delete bizCopy.businessesExtra;
            return {
              ...seCopy,
              scheduledEventsRecurring: [
                {
                  ...rec,
                  workReleaseDestinations: [{ ...wrd, businesses: [bizCopy] }],
                },
              ],
            };
          });
      }

      api
        .post(API_ENDPOINTS.bookingsCreate, finalPayload)
        .then(async (res) => {
          if (res?.data?.statusCode === 200) {
            if (!isNonEmptyVariable(payload?.bookingId)) {
              dispatch(
                setBookings({
                  bookingNumber: res?.data?.bookingNumber,
                  bookingId: res?.data?.bookingId,
                }),
              );
              dispatch(
                setLastBookingsFromAPI({
                  bookingNumber: res?.data?.bookingNumber,
                  bookingId: res?.data?.bookingId,
                }),
              );
              sessionStorage.setItem("createNewBooking", false);
              notificationService.success(
                "Success",
                "New Bookings created successfully",
              );
            } else {
              dispatch(
                setBookings({
                  ...payload,
                }),
              );
              dispatch(setLastBookingsFromAPI(payload));
              notificationService.success(
                "Success",
                "Booking updated successfully",
              );
            }
            // Editing an existing booking already knows the real bio/
            // arrestReport/inmateProperty ids, so save the extra tables now
            // and await it BEFORE the refresh below runs. onSearch's own GET
            // response doesn't include bio[0].bioExtra / arrestReports[0]
            // .arrestReportsExtra / inmateProperty[0].inmatePropertyExtra,
            // so dispatching it wipes them and this component's own
            // re-fetch effect fires immediately — if that race won against
            // this save actually reaching the backend, the re-fetch would
            // pull the pre-edit row and the UI would keep showing stale data
            // until a full page reload.
            if (anyExtraIdKnownBeforeSave) {
              await Promise.all([
                saveBioAndArrestReportsExtra(
                  bioExtraSnapshot,
                  arrestReportsExtraSnapshot,
                  bookings,
                ),
                saveInmatePropertyExtra(inmatePropertyExtraSnapshot, bookings),
                saveInmateMedicalExtra(inmateMedicalExtraSnapshot, bookings),
                saveCashAccountingNewExtra(
                  cashAccountingNewExtraSnapshot,
                  bookings,
                ),
              ]);
            }

            if (res?.data?.bookingNumber) {
              const searchResult = onSearch(res?.data?.bookingNumber, true);

              // A brand new booking doesn't know its bio/arrestReport/
              // inmateProperty ids until this refresh resolves, so that's
              // the earliest the extra tables (if any were filled in) can
              // be saved.
              if (!anyExtraIdKnownBeforeSave) {
                searchResult?.then((freshBookings) => {
                  if (!freshBookings) return;
                  saveBioAndArrestReportsExtra(
                    bioExtraSnapshot,
                    arrestReportsExtraSnapshot,
                    freshBookings,
                  );
                  saveInmatePropertyExtra(
                    inmatePropertyExtraSnapshot,
                    freshBookings,
                  );
                  saveInmateMedicalExtra(
                    inmateMedicalExtraSnapshot,
                    freshBookings,
                  );
                  saveCashAccountingNewExtra(
                    cashAccountingNewExtraSnapshot,
                    freshBookings,
                  );
                });
              }

              // Always resolved post-refresh (a new bail's real
              // bookingBailID is only known once refetched, matched by
              // bookingBailUuid) — doesn't fit the known-before-save split
              // above, see the bookingBailsSnapshot comment.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveBookingBailsExtra(bookingBailsSnapshot, freshBookings);
              });

              // Only holds that already had a real holdID before this save
              // get their holdsExtra saved (see saveHoldsExtra) — doesn't
              // need freshBookings, just fired alongside the above.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveHoldsExtra(holdsSnapshot);
              });

              // Same idea for Movement Rules' inmateMovementRulesExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveInmateMovementRulesExtra(movementRulesSnapshot);
              });

              // Same idea for Housing and Tracking's inmateTrackingExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveInmateTrackingExtra(inmateTrackingSnapshot);
              });

              // Same idea for each Property List item's
              // inmatePropertyItemsExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveInmatePropertyItemsExtra(inmatePropertyItemsSnapshot);
              });

              // Same idea for each Appointment Log entry's
              // appointmentLogExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveAppointmentLogExtra(appointmentLogSnapshot);
              });

              // Same idea for each Bio address's addressesExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveBioAddressesExtra(bioAddressesSnapshot);
              });

              // Same idea for a Job Schedule scheduled event's business's
              // businessesExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveBusinessesExtra(scheduledEventsSnapshot);
              });

              // Same idea for each Scheduled Event's own scheduledEventsExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveScheduledEventsExtra(scheduledEventsSnapshot);
              });

              // Same idea for each Cash Account transaction's
              // cashAccountingNewTransactionsExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveCashAccountingNewTransactionsExtra(
                  cashAccountingNewTransactionsSnapshot,
                );
              });

              // Same idea for each medication's medicationLog[]
              // medicationLogExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveMedicationLogExtra(medicationsSnapshot);
              });

              // Same idea for each victim notification's
              // victimNotificationExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveVictimNotificationExtra(victimNotificationsSnapshot);
              });

              // Same idea for each victim notification's
              // victimNotificationLog[].victimNotificationLogExtra.
              searchResult?.then((freshBookings) => {
                if (!freshBookings) return;
                saveVictimNotificationLogExtra(victimNotificationsSnapshot);
              });

              if (pendingTransportTriggers.length) {
                searchResult?.then((freshBookings) => {
                  if (!freshBookings) return;
                  const freshTracking = freshBookings?.inmateTracking || [];
                  if (
                    freshTracking.length !==
                    finalPayload?.bookings?.inmateTracking?.length
                  ) {
                    console.warn(
                      "Skipping Transport auto-create: inmateTracking count changed between save and resync.",
                    );
                    return;
                  }
                  const context = {
                    jacketID: freshBookings?.jacketId,
                    bioID: freshBookings?.bioId,
                    creatorStaffID: userDetails?.staffId,
                    housingAgency: agency,
                    jackets: freshBookings?.jackets,
                    bio: freshBookings?.bio,
                    cdInvolvements: freshBookings?.cdInvolvements,
                  };
                  const payloads = pendingTransportTriggers.flatMap(
                    ({ index }) =>
                      buildTransportPayloads(
                        { ...freshTracking[index] },
                        context,
                      ),
                  );
                  if (payloads.length)
                    createTransportsForNewMovements(payloads);
                });
              }
            }
            if (isBQ) {
              // getLatestBookings();
              bqCompleteSaveAction();
            }
            setSaveVisible(false);
            setSearchTxt("");
            setIsLoading(() => false);
            dispatch(setBookingsFieldsEnabled(false));
            if (
              !isScheduledBooking ||
              (isScheduledBooking &&
                bookings?.arrestReports?.[0]?.scheduledBookingCleared === true)
            ) {
              dispatch(setIsScheduledBooking(false));
            }

            setisLoadingHT(() => false);
            setTimeout(() => {
              setisShowTracking(() => false);
            }, 0);

            dispatch(setIrisSearchId(0));
            dispatch(setIrisEnrolleId(0));
          } else {
            notificationService.error(
              "Failed!",
              "New Bookings created failed!",
            );
          }
        })
        .catch((err) => {
          notificationService.error("Failed!", "New Bookings created failed");
        })
        .finally(() => {
          dispatch(setDeleteAPIEmpty());
          setIsLoading(() => false);
        });
    };

    const handleReleaseInmate = async (activeSubModules) => {
      const inmateReleaseArbitary = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.arbitary,
        LABELS_CAPITAL.VIEW,
        Arbitrary_Names.InmateRelease,
      );
      if (!inmateReleaseArbitary) {
        showDialog("info", {
          title: "Warning",
          content: `You do not have the Authority to release an Inmate`,
          confirmButtonText: "Ok",
        });
        return;
      }

      const payload = _.cloneDeep(bookings);

      const scheduledReleaseDate =
        payload?.arrestReports?.[0]?.scheduledReleaseDate;
      const scheduledReleaseTime =
        payload?.arrestReports?.[0]?.scheduledReleaseTime;
      const currentDateTime = dayjs();
      let charges = payload?.charges;
      let releaseDateTimeCharges;
      let releaseDate;
      let releaseTime;
      if (isNonEmptyVariable(charges)) {
        let controllingCharge = charges.find(
          (e) => e.controllingCharge == true,
        );
        if (isNonEmptyVariable(controllingCharge)) {
          releaseDate = controllingCharge?.scheduledReleaseDate;
          releaseTime = controllingCharge?.scheduledReleaseTime;
          if (
            isNonEmptyVariable(releaseDate) &&
            isNonEmptyVariable(releaseTime)
          )
            releaseDateTimeCharges = new Date(`${releaseDate} ${releaseTime}`);
        }
      }
      if (scheduledReleaseDate && scheduledReleaseTime) {
        const scheduledDateTime = dayjs(
          `${scheduledReleaseDate} ${scheduledReleaseTime}`,
        );

        if (scheduledDateTime.isAfter(currentDateTime)) {
          const data = await getRestrictForRelease(
            `Inmate is not scheduled to be released until that date ${bookings?.arrestReports?.[0]?.scheduledReleaseDate} at ${bookings?.arrestReports?.[0]?.scheduledReleaseTime}. Do wish to continue inmate release?`,
          );
          if (!data) {
            return;
          }
        }
      }
      if (releaseDateTimeCharges) {
        if (releaseDateTimeCharges.getTime() > Date.now()) {
          const data = await getRestrictForRelease(
            `Inmate is not scheduled to be released until that date ${releaseDate} at ${releaseTime}. Do wish to continue inmate release?`,
          );
          if (!data) {
            return;
          }
        }
      }
      Promise.all([
        allFormRef?.personalFormRef?.current?.validateFields(),
        allFormRef?.personalFormAliasesRef?.current?.validateFields(),
        allFormRef?.personalFormPlaceOfBirthRef?.current?.validateFields(),
        // allFormRef?.personalFormDistinguishingRef?.current?.validateFields(),
        allFormRef?.arrestbookFormRef?.current?.validateFields(),
        allFormRef?.inmateInfoRef?.current?.validateFields(),
        allFormRef?.propertyRef?.current?.validateFields(),
        allFormRef?.scheduledBookingRef?.current?.validateFields(),
      ])
        .then(() => {
          if (!bookings?.charges?.length) {
            notificationService.error("Validation Error", `Please add Charges`);
            tabChangeRef.current?.setSelectedGroup("arrest-report");
            setTimeout(() => {
              tabChangeRef.current?.onTabChange("charges");
            }, 0);
            return;
          }
          releaseInmate(activeSubModules);
        })
        .catch((err) => {
          let tabToChange = "personal-information";

          let requiredField = err?.errorFields[0]?.name[0];

          if (requiredField) {
            tabToChange =
              Object.keys(mandatoryFields).find((tab) =>
                mandatoryFields[tab].includes(requiredField),
              ) || "personal-information";
          }

          notificationService.error(
            "Validation Error",
            `Fill all mandatory fields in ${tabToChange
              .split("-")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")}`,
          );

          if (tabToChange === "property-taken-inmate") {
            tabChangeRef.current?.setSelectedGroup("inmate-property");
          } else {
            tabChangeRef.current?.setSelectedGroup("arrest-report");
          }

          setTimeout(() => {
            tabChangeRef.current?.onTabChange(tabToChange);
            // Move focus to the first error element
            setTimeout(() => {
              const firstErrorField = document.querySelector(
                `#${requiredField}`,
              );
              firstErrorField?.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
              firstErrorField?.focus();
            }, 300);
          }, 0);
        });
    };

    const buildPendingMovementMessage = (m) => {
      const scheduled =
        m?.scheduledDate && m?.scheduledTime
          ? `${m.scheduledDate} ${m.scheduledTime}`
          : "N/A";

      const expectedBack =
        m?.expectedBackDate && m?.expectedBackTime
          ? `${m.expectedBackDate} ${m.expectedBackTime}`
          : "N/A";

      const loanLoc = m?.inmateLocation;

      const loanTo = m?.loanType
        ? `${m.loanType}${m.loanDestination ? ` (${m.loanDestination})` : ""}`
        : m?.inmateLocation || "N/A";

      const approvedBy = m?.approvingOfficerStaffID
        ? getRefListNameByID("", m.approvingOfficerStaffID, true)
        : " ";

      const transportBy = m?.transportingOfficerStaffID
        ? getRefListNameByID("", m.transportingOfficerStaffID, true)
        : " ";

      let transprt = "";
      if (transportBy) {
        transprt = `Transport by ${transportBy}.`;
      }

      let approved = "";
      if (approvedBy) {
        approved = `Approved by ${approvedBy}.`;
      }

      return `
    This inmate has a pending movement scheduled for ${scheduled}.

    ${loanLoc} to ${loanTo}
    at ${scheduled}. ${transprt} Reason: ${m?.moveReason || "N/A"}. ${approved}
    Expected back at ${expectedBack}.

    Do you want to cancel it?
    `.trim();
    };

    const releaseInmate = async (activeSubModules) => {
      const payload = _.cloneDeep(bookings);
      delete payload?.genericInterfaceSubmission;
      delete payload?.medicalQuestionnaires;
      delete payload?.visitorLogBooking;

      const ch = payload?.charges?.find(
        (c) => c?.controllingCharge && c?.clearedToGo,
      );

      const bookingDateTime = getDayjsObject(
        payload?.arrestReports?.[0]?.incarcerationDate,
        payload?.arrestReports?.[0]?.incarcerationTime,
      );
      const releaseDateTime = getDayjsObject(
        ch?.clearanceDate,
        ch?.clearanceTime,
      );

      dispatch(
        setBookings({
          arrestReports: [
            {
              ...bookings?.arrestReports?.[0],
              releaseDate: ch?.clearanceDate || null,
              releaseTime: ch?.clearanceTime || null,
              releaseReasonId: ch?.clearanceReasonID || null,
              releaseOfficerStaffId: userDetails?.staffId || null,
              totalDaysInCustody:
                bookings?.detentions?.length &&
                isNonEmptyVariable(
                  bookings?.detentions?.[bookings?.detentions?.length - 1]
                    ?.lengthOfStay,
                )
                  ? bookings?.detentions?.[bookings?.detentions?.length - 1]
                      ?.lengthOfStay
                  : releaseDateTime?.diff(bookingDateTime, "day") != 0
                    ? releaseDateTime?.diff(bookingDateTime, "day")
                    : 1,
            },
          ],
        }),
      );

      const agency = user?.staff?.organization?.[0]?.agency;
      const preFinalPayload = cleanObject(payload);
      const finalPayload = {
        bookings: {
          ...preFinalPayload,
          // Also drops root copies of questionnaire-owned flags (see
          // excludeQuestionnaireInvolvements) - those carry no sub-type, and
          // re-sending them wiped the saved medicalTypeId/dangerTypeId/etc.
          cdInvolvements: sanitizeInvolvementsForSave(
            excludeQuestionnaireInvolvements(
              preFinalPayload?.cdInvolvements,
              bookings,
            ),
          ),
          creatorStaffId: userDetails?.staffId,
          inJail: false,
          user: userDetails?.username,
          jackets: [
            {
              ...((preFinalPayload?.jackets && preFinalPayload.jackets[0]) ||
                {}),
              jacketId: bookings?.["Folder ID"] || bookings?.jacketId || null,
              staffJacket: false,
              orphanFlag: false,
            },
          ],
          arrestReports: [
            {
              ...((preFinalPayload?.arrestReports &&
                preFinalPayload.arrestReports[0]) ||
                {}),
              housingAgency: agency,
              custodialAgency: agency,
              releaseDate: ch?.clearanceDate || null,
              releaseTime: ch?.clearanceTime || null,
              releaseReasonId: ch?.clearanceReasonID || null,
              releaseOfficerStaffId: userDetails?.staffId || null,
              totalDaysInCustody:
                preFinalPayload?.detentions?.length &&
                isNonEmptyVariable(
                  preFinalPayload?.detentions?.[
                    preFinalPayload?.detentions?.length - 1
                  ]?.lengthOfStay,
                )
                  ? preFinalPayload?.detentions?.[
                      preFinalPayload?.detentions?.length - 1
                    ]?.lengthOfStay
                  : releaseDateTime?.diff(bookingDateTime, "day") != 0
                    ? releaseDateTime?.diff(bookingDateTime, "day")
                    : 1,
            },
          ],
          bio: [
            {
              ...((preFinalPayload?.bio && preFinalPayload.bio[0]) || {}),
              bioPhotos:
                preFinalPayload?.bio[0]?.bioPhotos?.map((p) => {
                  return {
                    ...p,
                    lineupFlag: true,
                  };
                }) || [],
            },
          ],
        },
      };

      const currentDateTime = dayjs().format("MM/DD/YYYY HH:mm");
      finalPayload.bookings.arrestReports[0].releaseDate =
        currentDateTime.split(" ")[0];
      finalPayload.bookings.arrestReports[0].releaseTime =
        currentDateTime.split(" ")[1];
      // finalPayload.bookings.arrestReports[0].incarcerationDate =
      //   currentDateTime.split(" ")[0];
      // finalPayload.bookings.arrestReports[0].incarcerationTime =
      //   currentDateTime.split(" ")[1];
      finalPayload.bookings.arrestReports[0].releaseReasonId ??= 54240020;
      finalPayload.bookings.arrestReports[0].holdReasonId ??= 154530006;

      finalPayload.bookings.inmateTracking.push({
        inmateTrackingID: null,
        inmateLocation: "RELEASED",
        movementStatus: "Complete",
      });
      let isArrestReport = activeSubModules?.find((act) => {
        return act.value == "arrest-report";
      });

      if (
        finalPayload?.bookings?.charges?.length &&
        finalPayload?.bookings?.charges?.some(
          (c) =>
            c?.clearedToGo === false || !isNonEmptyVariable(c?.clearedToGo),
        )
      ) {
        if (!isArrestReport) {
          showDialog("info", {
            title: "Warning",
            content:
              "Arrest Report is disabled, enable it in config and try again.",
            confirmButtonText: "Ok",
          });
          return;
        }
        showDialog("info", {
          title: "Warning",
          content:
            "According to the arrest charges, the inmate is not yet cleared to go. You must clear all of the charges before the inmate can be released.",
          confirmButtonText: "Ok",
        });

        if (isArrestReport) {
          tabChangeRef.current?.setSelectedGroup("arrest-report");
        }

        setTimeout(() => {
          tabChangeRef.current?.onTabChange("charges");
        }, 0);

        return;
      }

      if (
        finalPayload?.bookings?.holds?.length &&
        finalPayload?.bookings?.holds?.some((c) => c?.holdStatus === "52180003")
      ) {
        if (!isArrestReport) {
          showDialog("info", {
            title: "Warning",
            content:
              "Arrest Report is disabled, enable it in config and try again.",
            confirmButtonText: "Ok",
          });
          return;
        }
        showDialog("info", {
          title: "Warning",
          content:
            "Inmate has holds and cannot be released. If you are trying to release the inmate to an agency that has a hold on them, edit the details of that Hold and change the Status to 'Hold for Transfer'.",
          confirmButtonText: "Ok",
        });
        if (isArrestReport) {
          tabChangeRef.current?.setSelectedGroup("arrest-report");
        }

        setTimeout(() => {
          tabChangeRef.current?.onTabChange("holds");
        }, 0);

        return;
      }

      if (finalPayload?.bookings?.holds?.length) {
        const transferHolds = finalPayload.bookings.holds.filter(
          (c) =>
            Number(c?.holdStatus) === 52180002 ||
            c?.holdStatus === "Hold for Transfer",
        );

        if (transferHolds.length) {
          const agencyNames = transferHolds
            .map((c) => c?.holdFor)
            .filter(Boolean)
            .join(" or ");
          const message = agencyNames
            ? `Inmate must be released to ${agencyNames}. Do you wish to continue inmate release?`
            : "Inmate must be released to the agency that has a hold on them. Do you wish to continue inmate release?";

          const data = await getRestrictForRelease(message);
          if (!data) {
            return;
          }
        }
      }

      if (
        finalPayload?.bookings?.bookingCashAccount?.[0]
          ?.cashAccountingNew?.[0] &&
        !finalPayload?.bookings?.bookingCashAccount?.[0]?.cashAccountingNew?.[0]
          ?.accountClosed
      ) {
        const data = await getRestrictForRelease(
          "The inmate's Cash Account is still open. Do you wish to continue inmate release?",
        );

        if (!data) {
          return;
        }
      }

      if (
        finalPayload?.bookings?.inmateProperty?.length &&
        finalPayload?.bookings?.inmateProperty?.some(
          (c) =>
            c?.propertyReleased === false ||
            !isNonEmptyVariable(c?.propertyReleased),
        )
      ) {
        const data = await getRestrictForRelease(
          "The Inmate still has property that has not been released. Do you wish to continue inmate release?",
        );

        if (!data) {
          return;
        }
      }

      let hasPendingMovementsToCancel = false;
      if (
        finalPayload?.bookings?.inmateTracking?.length &&
        finalPayload?.bookings?.inmateTracking?.some(
          (c) =>
            c?.movementStatus === "Pending" ||
            !isNonEmptyVariable(c?.movementStatus),
        )
      ) {
        const pendingMovements = finalPayload.bookings.inmateTracking
          .filter(
            (c) =>
              c?.movementStatus === "Pending" ||
              !isNonEmptyVariable(c?.movementStatus),
          )
          .sort((a, b) => b.inmateTrackingID - a.inmateTrackingID);

        if (!pendingMovements.length) {
          return;
        }

        hasPendingMovementsToCancel = true;

        for (const movement of pendingMovements) {
          const message = buildPendingMovementMessage(movement);
          const confirmed = await getRestrictForRelease(message);
          if (!confirmed) {
            return;
          }
          movement.movementStatus = "Cancelled";
        }
      }

      if (
        finalPayload?.bookings?.bookingBails?.length &&
        finalPayload?.bookings?.bookingBails?.some(
          (bb) => !isNonEmptyVariable(bb?.paid) || !bb?.paid,
        )
      ) {
        showDialog("info", {
          title: "Warning",
          content: "There are bails that are unpaid.",
          confirmButtonText: "Ok",
        });
        tabChangeRef.current?.setSelectedGroup("arrest-report");
        setTimeout(() => {
          tabChangeRef.current?.onTabChange("charges");
        }, 0);
        return;
      }

      if (finalPayload?.bookings?.victimNotifications?.length) {
        const data = await getRestrictForRelease(
          "Victims exist that have not been notified. Do you wish to continue inmate release?",
        );

        if (!data) {
          return;
        }
      }

      if (
        finalPayload?.bookings?.releaseNotes?.length &&
        finalPayload?.bookings?.releaseNotes?.some(
          (c) => !c?.cleared || isNonEmptyVariable(c?.holdStatus),
        )
      ) {
        const firstNote =
          finalPayload?.bookings?.releaseNotes?.[0]?.releaseNote ?? "";
        const firstCmt =
          finalPayload?.bookings?.releaseNotes?.[0]?.comments ?? "";

        let dispNote = "";
        if (firstNote && firstCmt) {
          dispNote = `RELEASE NOTE: ${firstNote}, ${firstCmt}.`;
        } else if (firstNote && !firstCmt) {
          dispNote = `RELEASE NOTE: ${firstNote}.`;
        }

        const data = await getRestrictForRelease(
          `${dispNote} Do you wish to continue inmate release?`,
        );

        if (!data) {
          return;
        }
      }

      finalPayload.bookings.readyForRelease = false;
      finalPayload.bookings.isNeedToSubmitGenericInterface = true;

      // These are called with separate API calls after the main booking save, so they don't need to be included in this payload.
      delete finalPayload.bookings.bio?.[0]?.bioExtra;
      delete finalPayload.bookings.arrestReports?.[0]?.arrestReportsExtra;
      if (Array.isArray(finalPayload.bookings.bookingBails)) {
        finalPayload.bookings.bookingBails =
          finalPayload.bookings.bookingBails.map((b) => {
            const copy = { ...b };
            delete copy.bookingBailsExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.holds)) {
        finalPayload.bookings.holds = finalPayload.bookings.holds.map((h) => {
          const copy = { ...h };
          delete copy.holdsExtra;
          return copy;
        });
      }
      if (Array.isArray(finalPayload.bookings.inmateMovementRule)) {
        finalPayload.bookings.inmateMovementRule =
          finalPayload.bookings.inmateMovementRule.map((r) => {
            const copy = { ...r };
            delete copy.inmateMovementRulesExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.inmateTracking)) {
        finalPayload.bookings.inmateTracking =
          finalPayload.bookings.inmateTracking.map((t) => {
            const copy = { ...t };
            delete copy.inmateTrackingExtra;
            return copy;
          });
      }
      if (
        Array.isArray(
          finalPayload.bookings.inmateProperty?.[0]?.inmatePropertyItems,
        )
      ) {
        finalPayload.bookings.inmateProperty[0].inmatePropertyItems =
          finalPayload.bookings.inmateProperty[0].inmatePropertyItems.map(
            (i) => {
              const copy = { ...i };
              delete copy.inmatePropertyItemsExtra;
              return copy;
            },
          );
      }
      if (Array.isArray(finalPayload.bookings.appointmentLog)) {
        finalPayload.bookings.appointmentLog =
          finalPayload.bookings.appointmentLog.map((a) => {
            const copy = { ...a };
            delete copy.appointmentLogExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.medications)) {
        finalPayload.bookings.medications =
          finalPayload.bookings.medications.map((m) => {
            if (!Array.isArray(m?.medicationLog)) return m;
            return {
              ...m,
              medicationLog: m.medicationLog.map((l) => {
                const copy = { ...l };
                delete copy.medicationLogExtra;
                return copy;
              }),
            };
          });
      }
      if (Array.isArray(finalPayload.bookings.victimNotifications)) {
        finalPayload.bookings.victimNotifications =
          finalPayload.bookings.victimNotifications.map((v) => {
            const copy = { ...v };
            delete copy.victimNotificationExtra;
            if (Array.isArray(copy.victimNotificationLog)) {
              copy.victimNotificationLog = copy.victimNotificationLog.map(
                (l) => {
                  const logCopy = { ...l };
                  delete logCopy.victimNotificationLogExtra;
                  return logCopy;
                },
              );
            }
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.bio?.[0]?.bioAddresses)) {
        finalPayload.bookings.bio[0].bioAddresses =
          finalPayload.bookings.bio[0].bioAddresses.map((ba) => {
            if (!ba?.addresses?.[0]) return ba;
            const addrCopy = { ...ba.addresses[0] };
            delete addrCopy.addressesExtra;
            return { ...ba, addresses: [addrCopy] };
          });
      }
      if (Array.isArray(finalPayload.bookings.scheduledEvents)) {
        finalPayload.bookings.scheduledEvents =
          finalPayload.bookings.scheduledEvents.map((se) => {
            const seCopy = { ...se };
            delete seCopy.scheduledEventsExtra;
            const rec = seCopy?.scheduledEventsRecurring?.[0];
            const wrd = rec?.workReleaseDestinations?.[0];
            const biz = wrd?.businesses?.[0];
            if (!biz?.businessesExtra) return seCopy;
            const bizCopy = { ...biz };
            delete bizCopy.businessesExtra;
            return {
              ...seCopy,
              scheduledEventsRecurring: [
                {
                  ...rec,
                  workReleaseDestinations: [{ ...wrd, businesses: [bizCopy] }],
                },
              ],
            };
          });
      }

      setIsLoading(() => true);
      api
        .post(API_ENDPOINTS.bookingsCreate, finalPayload)
        .then((res) => {
          if (res?.data?.statusCode === 200) {
            if (!isNonEmptyVariable(payload?.bookingId)) {
              dispatch(
                setBookings({
                  bookingNumber: res?.data?.bookingNumber,
                  bookingId: res?.data?.bookingId,
                }),
              );
              notificationService.success(
                "Success",
                "Inmate release successfully",
              );

              tabChangeRef.current?.setSelectedGroup("arrest-report");
              setTimeout(() => {
                tabChangeRef.current?.onTabChange("release-information");
              }, 0);
            } else {
              dispatch(
                setBookings({
                  ...payload,
                }),
              );
              notificationService.success(
                "Success",
                "Inmate release successfully",
              );
              tabChangeRef.current?.setSelectedGroup("arrest-report");
              setTimeout(() => {
                tabChangeRef.current?.onTabChange("release-information");
              }, 0);
            }
            onSearch(payload?.bookingNumber, true);
            if (hasPendingMovementsToCancel) {
              cancelPendingTransportsForJacket(
                finalPayload?.bookings?.jacketId,
              );
            }
            // getLatestBookings();
            if (isBQ) {
              bqCompleteSaveAction();
            }
          } else {
            notificationService.error("Failed!", "Inmate release failed!");
          }
        })
        .catch((err) => {
          notificationService.error("Failed!", "Inmate release failed");
        })
        .finally(() => {
          dispatch(setDeleteAPIEmpty());
          setIsLoading(() => false);
          cancelBookingsAction();
        });
    };

    const takeProperty = async () => {
      if (
        bookings?.inmateProperty?.[0]?.inmatePropertyItems?.length <= 0 ||
        !bookings?.inmateProperty?.[0]?.inmatePropertyItems
      ) {
        tabChangeRef.current?.onTabChange("property-taken-inmate");
      } else {
        tabChangeRef.current?.onTabChange("property-list");
      }
    };

    const releaseAllProperty = async () => {
      tabChangeRef.current?.onTabChange("property-taken-inmate");
      // Clone the current bookings payload and clean unwanted properties.
      const payload = _.cloneDeep(bookings);
      delete payload?.genericInterfaceSubmission;
      delete payload?.medicalQuestionnaires;
      delete payload?.visitorLogBooking;
      // If inmateProperty exists, update its items.
      if (
        payload &&
        payload.inmateProperty &&
        payload.inmateProperty.length > 0
      ) {
        const inmateProp = payload.inmateProperty[0];

        if (
          inmateProp.inmatePropertyItems &&
          inmateProp.inmatePropertyItems.length > 0 &&
          inmateProp.inmatePropertyItems[0].inventoryItems &&
          inmateProp.inmatePropertyItems[0].inventoryItems[0]
        ) {
          // 1. Extract storage locations from the first item's inventory
          const firstNonDisposedProperty = [
            ...inmateProp.inmatePropertyItems,
          ].find(
            (property) =>
              property?.inventoryItems?.[0]?.itemStatus !== "Disposed",
          );
          const loc1 =
            firstNonDisposedProperty?.inventoryItems?.[0]?.storageLocation1Id;
          const loc2 =
            firstNonDisposedProperty?.inventoryItems?.[0]?.storageLocation2Id;
          const loc3 =
            firstNonDisposedProperty?.inventoryItems?.[0]?.storageLocation3Id;

          // 2. Look up labels using your options arrays
          const storageLocation1Options = getOptionsFromRefList(
            "Storage_Location_1",
            false,
            false,
            true,
          );
          const storageLocation2Options = getOptionsFromRefList(
            "Inmate_Property_Storage_Location_1",
            false,
            false,
            true,
          );
          const storageLocation3Options = getOptionsFromRefList(
            "Inmate_Property_Storage_Location_2",
            false,
            false,
            true,
          );
          const loc1Name =
            storageLocation1Options.find((opt) => opt.value === loc1)?.label ||
            "";
          const loc2Name =
            storageLocation2Options.find((opt) => opt.value === loc2)?.label ||
            "";
          const loc3Name =
            storageLocation3Options.find((opt) => opt.value === loc3)?.label ||
            "";

          // 3. Build the property comments string
          const propertyComments = `PROPERTY LOCATION - ${loc1Name} ${loc2Name} ${loc3Name}`;
          // 4. Update each inmate property item: clear storage locations and set itemStatus to "Disposed"
          inmateProp.inmatePropertyItems = inmateProp.inmatePropertyItems.map(
            (item) => {
              if (item.inventoryItems && item.inventoryItems[0]) {
                item.inventoryItems[0].storageLocation1Id = "";
                item.inventoryItems[0].storageLocation2Id = "";
                item.inventoryItems[0].storageLocation3Id = "";
                item.inventoryItems[0].itemStatus = "Disposed";
                item.inventoryItems[0].disposalType = "Return to Owner";
              }
              return item;
            },
          );

          // 5. Update the outer inmate property with the new propertyComments.
          inmateProp.propertyComments = propertyComments;
          inmateProp.propertyReleased = true;
        }
      }

      const agency = user?.staff?.organization?.[0]?.agency;

      // Clean up the payload further if needed.
      const preFinalPayload = cleanObject(payload);

      // Construct finalPayload with additional fields.
      const finalPayload = {
        bookings: {
          ...preFinalPayload,
          // Also drops root copies of questionnaire-owned flags (see
          // excludeQuestionnaireInvolvements) - those carry no sub-type, and
          // re-sending them wiped the saved medicalTypeId/dangerTypeId/etc.
          cdInvolvements: sanitizeInvolvementsForSave(
            excludeQuestionnaireInvolvements(
              preFinalPayload?.cdInvolvements,
              bookings,
            ),
          ),
          creatorStaffId: userDetails?.staffId,
          user: userDetails?.username,
          jackets: [
            {
              ...((preFinalPayload?.jackets && preFinalPayload.jackets[0]) ||
                {}),
              staffJacket: false,
              orphanFlag: false,
            },
          ],
          arrestReports: [
            {
              ...((preFinalPayload?.arrestReports &&
                preFinalPayload.arrestReports[0]) ||
                {}),
              housingAgency: agency,
              custodialAgency: agency,
            },
          ],
          bio: [
            {
              ...((preFinalPayload?.bio && preFinalPayload.bio[0]) || {}),
              bioPhotos:
                preFinalPayload?.bio[0]?.bioPhotos?.map((p) => {
                  return {
                    ...p,
                    lineupFlag: true,
                  };
                }) || [],
            },
          ],
        },
      };

      // These are called with separate API calls after the main booking save, so they don't need to be included in this payload.
      delete finalPayload.bookings.bio?.[0]?.bioExtra;
      delete finalPayload.bookings.arrestReports?.[0]?.arrestReportsExtra;
      if (Array.isArray(finalPayload.bookings.bookingBails)) {
        finalPayload.bookings.bookingBails =
          finalPayload.bookings.bookingBails.map((b) => {
            const copy = { ...b };
            delete copy.bookingBailsExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.holds)) {
        finalPayload.bookings.holds = finalPayload.bookings.holds.map((h) => {
          const copy = { ...h };
          delete copy.holdsExtra;
          return copy;
        });
      }
      if (Array.isArray(finalPayload.bookings.inmateMovementRule)) {
        finalPayload.bookings.inmateMovementRule =
          finalPayload.bookings.inmateMovementRule.map((r) => {
            const copy = { ...r };
            delete copy.inmateMovementRulesExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.inmateTracking)) {
        finalPayload.bookings.inmateTracking =
          finalPayload.bookings.inmateTracking.map((t) => {
            const copy = { ...t };
            delete copy.inmateTrackingExtra;
            return copy;
          });
      }
      if (
        Array.isArray(
          finalPayload.bookings.inmateProperty?.[0]?.inmatePropertyItems,
        )
      ) {
        finalPayload.bookings.inmateProperty[0].inmatePropertyItems =
          finalPayload.bookings.inmateProperty[0].inmatePropertyItems.map(
            (i) => {
              const copy = { ...i };
              delete copy.inmatePropertyItemsExtra;
              return copy;
            },
          );
      }
      if (Array.isArray(finalPayload.bookings.appointmentLog)) {
        finalPayload.bookings.appointmentLog =
          finalPayload.bookings.appointmentLog.map((a) => {
            const copy = { ...a };
            delete copy.appointmentLogExtra;
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.medications)) {
        finalPayload.bookings.medications =
          finalPayload.bookings.medications.map((m) => {
            if (!Array.isArray(m?.medicationLog)) return m;
            return {
              ...m,
              medicationLog: m.medicationLog.map((l) => {
                const copy = { ...l };
                delete copy.medicationLogExtra;
                return copy;
              }),
            };
          });
      }
      if (Array.isArray(finalPayload.bookings.victimNotifications)) {
        finalPayload.bookings.victimNotifications =
          finalPayload.bookings.victimNotifications.map((v) => {
            const copy = { ...v };
            delete copy.victimNotificationExtra;
            if (Array.isArray(copy.victimNotificationLog)) {
              copy.victimNotificationLog = copy.victimNotificationLog.map(
                (l) => {
                  const logCopy = { ...l };
                  delete logCopy.victimNotificationLogExtra;
                  return logCopy;
                },
              );
            }
            return copy;
          });
      }
      if (Array.isArray(finalPayload.bookings.bio?.[0]?.bioAddresses)) {
        finalPayload.bookings.bio[0].bioAddresses =
          finalPayload.bookings.bio[0].bioAddresses.map((ba) => {
            if (!ba?.addresses?.[0]) return ba;
            const addrCopy = { ...ba.addresses[0] };
            delete addrCopy.addressesExtra;
            return { ...ba, addresses: [addrCopy] };
          });
      }
      if (Array.isArray(finalPayload.bookings.scheduledEvents)) {
        finalPayload.bookings.scheduledEvents =
          finalPayload.bookings.scheduledEvents.map((se) => {
            const seCopy = { ...se };
            delete seCopy.scheduledEventsExtra;
            const rec = seCopy?.scheduledEventsRecurring?.[0];
            const wrd = rec?.workReleaseDestinations?.[0];
            const biz = wrd?.businesses?.[0];
            if (!biz?.businessesExtra) return seCopy;
            const bizCopy = { ...biz };
            delete bizCopy.businessesExtra;
            return {
              ...seCopy,
              scheduledEventsRecurring: [
                {
                  ...rec,
                  workReleaseDestinations: [{ ...wrd, businesses: [bizCopy] }],
                },
              ],
            };
          });
      }

      setIsLoading(() => true);
      api
        .post(API_ENDPOINTS.bookingsCreate, finalPayload)
        .then((res) => {
          if (res?.data?.statusCode === 200) {
            if (!isNonEmptyVariable(payload?.bookingId)) {
              dispatch(
                setBookings({
                  bookingNumber: res?.data?.bookingNumber,
                  bookingId: res?.data?.bookingId,
                }),
              );
              notificationService.success(
                "Success",
                "Inmate property released successfully",
              );
            } else {
              dispatch(setBookings({ ...payload }));
              notificationService.success(
                "Success",
                "Inmate property released successfully",
              );
            }
            if (searchTxt === "" || isBQ) {
              // getLatestBookings();
            }
            if (isBQ) {
              bqCompleteSaveAction();
            }
          } else {
            notificationService.error(
              "Failed!",
              "Inmate property release failed!",
            );
          }
        })
        .catch((err) => {
          notificationService.error(
            "Failed!",
            "Inmate property release failed",
          );
        })
        .finally(() => {
          setIsLoading(() => false);
          dispatch(setDeleteAPIEmpty());
        });
    };

    const getRestrictForRelease = (content) => {
      return new Promise((resolve, reject) => {
        showDialog("confirm", {
          title: "Warning",
          content: content,
          onConfirm: () => {
            resolve(true);
          },
          onCancel: () => {
            resolve(false);
          },
        });
      });
    };

    // skipClear: post-save refreshes call this to re-pull the same booking
    // that's already on screen. Clearing `bookings` first (as a fresh manual
    // search does, to avoid flashing stale data from a different booking)
    // opens a gap where bio is momentarily null - InmateHeader then falls
    // back to its hardcoded "New Warrant" title until the GET below resolves.
    // Skipping the clear for a same-booking refresh keeps the header showing
    // the current name throughout instead of flashing that fallback.
    const onSearch = (value, skipClear = false) => {
      setIsLoading(() => false);
      if (value === "") {
        setSearchTxt("");
        return;
      }
      if (isNaN(value)) {
        notificationService.error("Please enter a valid Booking Number");
        return;
      } else {
        if (!skipClear) dispatch(setBookingsNull());
        setSearchTxt(value);
        setIsLoading(true);
        return api
          .get(API_ENDPOINTS.getBookingByID + value)
          .then(async (response) => {
            if (response.status === 200 && response.data) {
              const flagsData = await getFlagsByJacketID(response.data);
              const bookingsWithFlags = {
                ...response.data,
                cdInvolvements: mergeFlagsIntoInvolvements(
                  response.data?.cdInvolvements,
                  flagsData,
                ),
              };
              // Fetch BioExtra/ArrestReportsExtra and merge them in right
              // here, before the very first dispatch — so Additional
              // Personal/Booking Information have their data on the same
              // render as the rest of the booking, instead of a brief
              // empty flash while useBioExtraSync/useArrestReportsExtraSync
              // catch up afterward.
              const merged =
                await fetchAndMergeBookingExtras(bookingsWithFlags);
              dispatch(setBookings(merged));
              dispatch(setLastBookingsFromAPI(merged));
              return merged;
            } else {
              notificationService.error("No record found");
            }
          })
          .catch((error) => {
            notificationService.error("No record found");
          })
          .finally(() => {
            setIsLoading(false);
          });
      }
    };

    const handleScheduledBooking = () => {
      newBookingsAction(null, true);
    };

    const handleSelectBookingNumber = async (value) => {
      dispatch(setBookingsNull());
      dispatch(setLastBookingsFromAPI(null));
      setReportListLoading(true);
      try {
        const response = await api.get(API_ENDPOINTS.getBookingByID + value);
        if (response.status === 200 && response.data) {
          // Show the core booking right away instead of waiting on the
          // flags/extras enrichment below - those two calls used to run
          // first, in the same try, so any failure in either of them (e.g.
          // a missing jacketId, a slow/erroring extras endpoint) fell
          // through to the outer catch, which only logs to console. Nothing
          // ever got dispatched, leaving the screen stuck on the
          // setBookingsNull() reset above with no visible error at all.
          dispatch(setBookings(response.data));
          dispatch(setLastBookingsFromAPI(response.data));
          dispatch(setShowBookings(true));

          try {
            const flagsData = await getFlagsByJacketID(response.data);
            const bookingsWithFlags = {
              ...response.data,
              cdInvolvements: mergeFlagsIntoInvolvements(
                response.data?.cdInvolvements,
                flagsData,
              ),
            };
            const merged = await fetchAndMergeBookingExtras(bookingsWithFlags);
            dispatch(setBookings(merged));
            dispatch(setLastBookingsFromAPI(merged));
          } catch (enrichErr) {
            console.error(
              "[handleSelectBookingNumber] flags/extras enrichment failed:",
              enrichErr,
            );
          }
        } else {
          notificationService.error("No record found");
        }
      } catch (err) {
        console.error(err);
        notificationService.error("No record found");
      } finally {
        setReportListLoading(false);
      }
    };

    const getFlagsByJacketID = async (bookingsData) => {
      const url = API_ENDPOINTS.getFlagByJacketID + bookingsData?.jacketId;
      const response = await api.get(url);
      // The flag badges/dialog show saved flags from this response only -
      // see getDisplayInvolvements.
      dispatch(
        setJacketFlags({
          jacketId: bookingsData?.jacketId,
          flags: response?.data,
        }),
      );
      return response?.data;
    };

    const getReportListData = async (sort = sortInfo) => {
      try {
        setReportListLoading(true);
        setReportListData([]);
        setFilteredReportListData([]);

        let url = `${API_ENDPOINTS.bookingsSearch}?direction=${sort.direction ?? "DESC"}`;

        if (sort.orderBy) {
          url += `&orderBy=${sort.orderBy}`;
        }

        const obj = {
          page: tablePagination.pageIndex,
          size: tablePagination.pageSize,
        };

        const urlParam = toQueryString(obj);

        if (isNonEmptyVariable(urlParam)) {
          url += "&" + urlParam;
        }

        let payload = bookingSearchPayload;

        if (!isFiltered) {
          payload = [
            ...bookingSearchPayload,
            { filterKey: "isBookingList", value: true },
          ];
        }

        const result = await api.post(url, payload);

        // const injailList = result?.data?.rows?.filter(
        //   (r) => r?.currentLocation === "In Jail"
        // );
        if (!isFiltered) {
          setReportListTotal(result?.data?.total);
        }
        setReportListData(() => result?.data?.rows);
        setFilteredReportListData(() => result?.data?.rows);
      } catch (err) {
        setReportListData([]);
        setFilteredReportListData([]);
      } finally {
        setReportListLoading(false);
      }
    };

    const handleChangePagination = (pageIndex, pageSize) => {
      isPageRef.current = true;
      setTablePagination({
        pageIndex,
        pageSize,
      });
    };

    const sortKeyMap = {
      name: "lName",
      incarcerationDate: "incarcerationDate",
      releaseDate: "releaseDate",
      destination: "housingLocation",
      housingLocation: "currentLocation",
    };

    const handleTableChange = (pagination, filters, sorter) => {
      const columnKey = sorter?.order ? sorter.columnKey : null;
      const newSort = {
        orderBy: columnKey ? (sortKeyMap[columnKey] ?? columnKey) : null,
        direction:
          sorter?.order === "ascend"
            ? "ASC"
            : sorter?.order === "descend"
              ? "DESC"
              : "ASC",
      };
      setSortInfo(newSort);
      if (isPageRef.current) {
        isPageRef.current = false;
        return;
      }
      getReportListData(newSort);
    };

    // const handleBackToList = () => {
    //   setBookingSearchPayload([
    //     { filterKey: "searchType", value: "Starts With" },
    //     // { filterKey: "custodyStatus", value: "In Custody" },
    //   ]);
    //   setPagination({
    //     pageIndex: 0,
    //     pageSize: 100,
    //   });
    //   setTablePagination({
    //     pageIndex: 0,
    //     pageSize: 100,
    //   });
    //   setIsFiltered(false);
    //   dispatch(setShowBookings(false));
    //   dispatch(setBookingsNull());
    //   sessionStorage.setItem("createNewBooking", false);
    //   setSearchTxt("");
    //   dispatch(setIrisSearchId(0));
    //   dispatch(setIrisEnrolleId(0));
    //   dispatch(setIsScheduledBooking(false));
    //   dispatch(setFullSearch(false));
    // };

    const handleBackToList = () => {
      // Only switch view
      dispatch(setShowBookings(false));

      // Reset pagination but KEEP filters
      setPagination({
        pageIndex: 0,
        pageSize: 100,
      });

      setTablePagination({
        pageIndex: 0,
        pageSize: 100,
      });

      // Without this, the Search/Enroll Iris bar (hidden while
      // isFiltered is true, so it doesn't sit on top of Full Search
      // results) would stay hidden forever after Cancel - isFiltered
      // was never cleared here, so a later Full Search could never
      // show that bar again.
      setIsFiltered(false);
    };

    const handleClearFilter = () => {
      const defaultPayload = [
        { filterKey: "searchType", value: "Starts With" },
      ];

      setBookingSearchPayload(defaultPayload);

      setPagination({
        pageIndex: 0,
        pageSize: 100,
      });

      setTablePagination({
        pageIndex: 0,
        pageSize: 100,
      });

      setIsFiltered(false);
      setSearchTxt("");

      dispatch(setShowBookings(false));
      dispatch(setBookingsNull());
      dispatch(setIrisSearchId(0));
      dispatch(setIrisEnrolleId(0));
      dispatch(setIsScheduledBooking(false));
      dispatch(setFullSearch(false));
    };

    const handleClear = () => {
      setBookingSearchPayload([
        { filterKey: "searchType", value: "Starts With" },
        // { filterKey: "custodyStatus", value: "In Custody" },
      ]);
      setPagination({
        pageIndex: 0,
        pageSize: 100,
      });
      setTablePagination({
        pageIndex: 0,
        pageSize: 100,
      });
      setIsFiltered(false);
      setSearchTxt("");
    };

    const handleCancel = () => {
      setShowFilter(false);
    };

    const handleFilter = () => {
      setShowFilter(true);
    };

    const onDelete = async () => {
      if (!bookings.bookingId) {
        const data = await getLatestBookingsUtil();
        dispatch(setLastBookingsFromAPI(data));
        dispatch(
          setBookings({
            ...data,
          }),
        );

        return;
      }

      const content = `You are deleting Bookings ${bookings?.bookingNumber}. Are you sure you want to delete all information for this record?`;
      const canDelete = await new Promise((resolve, reject) => {
        showDialog("confirm", {
          title: "Warning",
          content: content,
          onConfirm: () => {
            resolve(true);
          },
          onCancel: () => {
            resolve(false);
          },
        });
      });

      if (!canDelete) {
        return;
      }

      setIsDeleting(true);
      api
        .delete(API_ENDPOINTS.bookingsByBookingId + bookings.bookingId)
        .then(async (response) => {
          setIsDeleting(false);
          dispatch(setBookingsNull());
          dispatch(setLastBookingsFromAPI([]));

          notificationService.success(
            "Success!",
            "Booking data deleted successfully",
          );

          // Navigate back to the Bookings main (list) page instead of
          // loading another record into the detail view.
          setSaveVisible(false);
          dispatch(setBookingsFieldsEnabled(false));
          dispatch(setShowBookings(false));
          getReportListData();
        })
        .finally(() => {
          setIsDeleting(false);
          dispatch(setIrisSearchId(0));
          dispatch(setIrisEnrolleId(0));
        });
    };

    // IRIS Search
    const [irisSearchData, setIrisSearchData] = useState();
    const { irisDeviceConnected } = useIrisDevice();

    const irisSearchDataEmit = (irisData) => {
      setIrisSearchData(irisData);
    };

    // Iris History: looks up the booking's already-enrolled EnrolleeID against
    // the iris repository (no scanner involved) and shows the results in a
    // read-only SearchIrisDetailsPopup.
    const handleIrisHistory = () => {
      const enrolleeId = bookings?.bio?.[0]?.enrolleeId;
      if (!isNonEmptyVariable(enrolleeId)) return;

      setIrisHistoryLoading(true);
      const urlList =
        API_ENDPOINTS.irisListSearch + `?enrollId=${enrolleeId}&searchId=0`;
      api
        .get(urlList)
        .then((res) => {
          setIrisHistoryData(res?.data);
          setIrisHistoryPopupOpen(true);
        })
        .catch(() => {
          notificationService.error(
            "Unable to fetch Iris history at this time.",
          );
        })
        .finally(() => {
          setIrisHistoryLoading(false);
        });
    };

    const openIrisSearch = (action) => {
      setIsLoading(() => true);
      const url = "http://localhost:6191/iris/check-fidentPSE";
      api
        .get(url)
        .then((response) => {
          if (response?.data?.status === "Success") {
            dispatch(setIrisSearchId(0));
            dispatch(setIrisEnrolleId(0));
            openIrisScannerWindow(action);
          } else {
            setIsLoading(() => false);
            notificationService.error(
              "Fident PSE service is not running. Please start the service to use Iris Search.",
            );
          }
        })
        .catch((error) => {
          console.error("Error checking FidentPSE status:", error);
          setIsLoading(() => false);
          notificationService.error(
            "Fident PSE service is not running. Please start the service to use Iris Search.",
          );
        });
    };

    const saveIrisVerifyAuditLog = (extraText) => {
      const bookingsModuleId = configModules?.find(
        (m) => m?.moduleName === MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
      )?.moduleID;
      api.post(API_ENDPOINTS.auditLogSave, {
        systemAuditLogId: 0,
        dateAdded: dayjs().format("MM/DD/YYYY"),
        timeAdded: dayjs().format("HH:mm"),
        user: userDetails?.username,
        action: "External Interface",
        rootAppContext: "Bookings",
        rootAppContextKeyFieldId: bookings?.bookingId || 0,
        appContext: "Bookings",
        appContextKeyFieldId: null,
        fullFieldSource: null,
        extraText,
        moduleId: bookingsModuleId || 0,
        creatorStaffId: userDetails?.staffId,
        recordNumber: bookings?.bookingNumber,
      });
    };

    const openIrisScannerWindow = (action) => {
      setIsLoading(() => true);
      const url = "http://localhost:6191/iris/searchIris";
      api
        .get(url)
        .then((res) => {
          if (res?.data?.Result === "Cancel") {
            showDialog("info", {
              title: "Cancelled by User",
              confirmButtonText: "Ok",
            });
            setIsLoading(() => false);
            return;
          }
          if (isNonEmptyVariable(res?.data)) {
            const resDataPre = res?.data;
            dispatch(setIrisSearchId(resDataPre?.TransactionId || 0));
            dispatch(
              setIrisEnrolleId(
                resDataPre?.EnrolleeId !== 0 ? resDataPre?.EnrolleeId : 0 || 0,
              ),
            );

            if (resDataPre?.EnrolleeId === 0 && action === "verify") {
              noDataFound();
              return;
            }
            if (
              resDataPre?.EnrolleeId &&
              isNonEmptyVariable(bookings?.bio?.[0]?.enrolleeId) &&
              action === "verify"
            ) {
              if (resDataPre?.EnrolleeId == bookings?.bio?.[0]?.enrolleeId) {
                saveIrisVerifyAuditLog(
                  `Verify Iris: Match on EnrolleeID ${resDataPre?.EnrolleeId}`,
                );
                showDialog("info", {
                  title: "IMATS IRIS Search - Match!",
                  content: `Match on EnrolleeID ${resDataPre?.EnrolleeId}`,
                  confirmButtonText: "Ok",
                  cancelButtonText: "No",
                  onConfirm: () => {
                    irisSearchDataEmit(null);
                    setIrisSearchData(null);
                  },
                });
              } else {
                saveIrisVerifyAuditLog(
                  `Verify Iris: EnrolleeIDs do not match. Iris scan returned data for a different person:\nEnrolleeID: ${resDataPre?.EnrolleeId || null}\nBooking #: ${resDataPre?.BookingNumber || ""}\nLast Name: ${resDataPre?.LastName || ""}\nFirst Name: ${resDataPre?.FirstName || ""}`,
                );
                showDialog("info", {
                  title: "IMATS IRIS Search - No Match!",
                  content: (
                    <div>
                      <p>
                        EnrolleeIDs do not match. Iris scan returned data for a
                        different person
                      </p>
                      <p>EnrolleeID: {resDataPre?.EnrolleeId || null}</p>
                      <p>Booking #: {resDataPre?.BookingNumber || ""}</p>
                      <p>Last Name: {resDataPre?.LastName || ""}</p>
                      <p>First Name: {resDataPre?.FirstName || ""}</p>
                    </div>
                  ),
                  confirmButtonText: "Ok",
                  cancelButtonText: "No",
                  onConfirm: () => {
                    irisSearchDataEmit(null);
                    setIrisSearchData(null);
                  },
                });
              }
            } else if (action === "enroll") {
              return handleEnrollIrisResult(resDataPre);
            } else {
              dispatch(
                setBookings({
                  bio: [
                    {
                      ...bookings?.bio?.[0],
                      enrolleeId:
                        resDataPre?.EnrolleeId ||
                        bookings?.bio?.[0]?.enrolleeId ||
                        null,
                    },
                  ],
                }),
              );
            }
          } else {
            dispatch(setIrisSearchId(0));
            if (action === "verify") {
              noDataFound();
            }
          }
        })
        .finally(() => {
          setIsLoading(() => false);
        });
    };

    const setEnrolleeId = (enrolleeId) => {
      dispatch(
        setBookings({
          bio: [
            {
              ...bookings?.bio?.[0],
              enrolleeId: enrolleeId || null,
            },
          ],
        }),
      );
    };

    const handleEnrollIrisResult = (resDataPre) => {
      const enrollId = resDataPre?.EnrolleeId || 0;
      const searchId = resDataPre?.TransactionId || 0;

      if (!enrollId) {
        setEnrolleeId(0);
        return;
      }

      return api
        .get(
          `${API_ENDPOINTS.irisListSearch}?enrollId=${enrollId}&searchId=${searchId}`,
        )
        .then((resList) => {
          const enrolledIrisList = resList?.data?.enrolledIrisList;

          if (!enrolledIrisList?.length) {
            setEnrolleeId(enrollId);
            return;
          }

          // Scenario 1: a matched enrollee record that is still in jail (not
          // released) always blocks enrollment — the jacket does not need to
          // be checked in this case.
          const inJailRecord = enrolledIrisList.find(
            (record) =>
              record?.dateReleased === UNRELEASED_DATE &&
              record?.isLocalDataMatched === true,
          );

          if (inJailRecord) {
            return api
              .get(API_ENDPOINTS.getBookingByID + inJailRecord?.bookingNumber)
              .then((bookingRes) => {
                const scannedJacketId = bookingRes?.data?.jacketId;

                showDialog("info", {
                  title: "Invalid Enrollee",
                  content: (
                    <div>
                      <p>
                        Invalid Enrollee. The inmate just scanned has previously
                        been enrolled.
                      </p>
                      <p>Folder ID: {scannedJacketId}</p>
                      <p>Booking Number: {inJailRecord?.bookingNumber}</p>
                    </div>
                  ),
                  confirmButtonText: "Ok",
                });
              });
          }

          // Scenario 2: a matched enrollee record that has been released only
          // blocks enrollment if it belongs to a different jacket.
          const releasedRecord = enrolledIrisList.find(
            (record) =>
              record?.dateReleased !== UNRELEASED_DATE &&
              record?.isLocalDataMatched === true,
          );

          if (!releasedRecord) {
            setEnrolleeId(enrollId);
            return;
          }

          return api
            .get(API_ENDPOINTS.getBookingByID + releasedRecord?.bookingNumber)
            .then((bookingRes) => {
              const scannedJacketId = bookingRes?.data?.jacketId;
              const currentJacketId =
                bookings?.["Folder ID"] || bookings?.jacketId;

              if (`${scannedJacketId}` === `${currentJacketId}`) {
                setEnrolleeId(enrollId);
                return;
              }

              showDialog("info", {
                title: "Folder Mismatch",
                content: (
                  <div>
                    <p>
                      The iris scan just performed is associated with Folder
                      that does not match the current Folder.
                    </p>
                    <p>Folder ID for this Booking: {currentJacketId}</p>
                    <p>Folder ID for the Iris Scan: {scannedJacketId}</p>
                  </div>
                ),
                confirmButtonText: "Ok",
              });
            });
        });
    };

    const noDataFound = () => {
      showDialog("info", {
        title: "IMATS IRIS Search - No Match!",
        content: (
          <div>
            <p>
              EnrolleeIDs do not match. Iris scan returned data for a different
              person
            </p>
            <p>EnrolleeID: 0</p>
            <p>Booking #:</p>
            <p>Last Name:</p>
            <p>First Name:</p>
          </div>
        ),
        confirmButtonText: "Ok",
        onConfirm: () => {
          irisSearchDataEmit(null);
          setIrisSearchData(null);
        },
      });
    };

    const getMessage = (enrollee_id, isLocalMatch) => {
      return (
        <>
          <p>
            <b>*NOTE</b>: The inmate just scanned has {!isLocalMatch && "no"}{" "}
            IRIS enrolled folder in the local system
            {!isLocalMatch && ", but WAS found in the national IRIS repository"}
            .
          </p>
          <p>
            Would you like to see additional info about IRIS EnrolleeID{" "}
            {enrollee_id} from the national IRIS repository?
          </p>
        </>
      );
    };
    const isAddDisabled =
      reportListLoading ||
      isConfiguring ||
      !hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.module,
        LABELS_CAPITAL.ADD,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
      ) ||
      (!hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.ADD,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report,
      ) &&
        !hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.ADD,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
        ) &&
        !hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.ADD,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Property,
        ) &&
        !hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.ADD,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Inmate_Officer_Reports,
        ));

    const subModuleMap = {
      "arrest-report": SUB_MODULES_LIST_WITH_ID.Arrest_Report,
      "inmate-medical": SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
      "inmate-property": SUB_MODULES_LIST_WITH_ID.Inmate_Property,
      "inmate-inmate-officer-reports":
        SUB_MODULES_LIST_WITH_ID.Inmate_Officer_Reports,
    };

    // Modify Access Check
    const hasBookingModifyAccess = hasCheckSecurity(
      Security_Types.functionality,
      Entity_types.module,
      LABELS_CAPITAL.MODIFY,
      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
    );

    const hasSelectedSubModuleModifyAccess = selectedGroup
      ? hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.MODIFY,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          subModuleMap[selectedGroup],
        )
      : false;

    const isModifyDisabled =
      !hasBookingModifyAccess || !hasSelectedSubModuleModifyAccess;

    // DELETE Access Check
    const hasBookingDeleteAccess = hasCheckSecurity(
      Security_Types.functionality,
      Entity_types.module,
      LABELS_CAPITAL.DELETE,
      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
    );

    const hasSelectedSubModuleDeleteAccess = selectedGroup
      ? hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.DELETE,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          subModuleMap[selectedGroup],
        )
      : false;

    const isDeleteDisabled =
      !hasBookingDeleteAccess || !hasSelectedSubModuleDeleteAccess;

    // Exposes the same Save/Cancel actions the inline action bar below uses,
    // so a parent Modal (Booking Queue / Release Queue step flow) can drive
    // them from its own footer buttons instead of this page's inline bar.
    useImperativeHandle(ref, () => ({
      triggerSave: () => preSaveBookingAction(),
      triggerCancel: () => cancelBookingsAction(),
    }));

    useEffect(() => {
      onFooterStateChange?.({ isLoading, isModifyDisabled });
    }, [isLoading, isModifyDisabled]);

    return (
      <StyledBookingsContainer data-lenis-prevent headerHeight={headerHeight}>
        <StyledGridRow justify="space-between">
          <StyledGridCol span={24}>
            <StyledDarkSectionTitle bgColor="rgb(4 28 45)">
              <span>Bookings</span>
            </StyledDarkSectionTitle>
          </StyledGridCol>
        </StyledGridRow>

        {!fromFolderDetails && !isBQ && (
          <>
            {/* Once a Full Search's results are showing (isFiltered), this
                bar's Search/Enroll Iris buttons no longer apply - you're
                viewing a multi-row results list, not composing a search
                against a single record. Hide it until a new search starts
                (handleBackToList resets isFiltered). */}
            {saveVisible || (fullSearch && !isFiltered) ? (
              <StyledActionControlContainer>
                <Flex gap={10}>
                  <Button
                    color="warning"
                    variant="solid"
                    onClick={
                      fullSearch ? fullSearchAction : preSaveBookingAction
                    }
                    disabled={isLoading || isModifyDisabled}
                  >
                    {fullSearch ? "Search" : "Save Changes"}
                  </Button>
                  {!fullSearch && !isBQ && showBookings && (
                    <Button
                      color="primary"
                      variant="solid"
                      onClick={onDelete}
                      loading={isDeleting}
                      disabled={isDeleteDisabled}
                    >
                      Expunge
                    </Button>
                  )}
                  {!isBQ &&
                    (bookings?.bio?.[0]?.enrolleeId === 0 ||
                      !isNonEmptyVariable(bookings?.bio?.[0]?.enrolleeId)) && (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        onClick={() => openIrisSearch("enroll")}
                        icon={<EyeOutlined />}
                        disabled={!irisDeviceConnected}
                      >
                        Enroll Iris
                      </Button>
                    )}
                </Flex>

                {!isBQ && (
                  <Button
                    color="primary"
                    type="primary"
                    variant="solid"
                    onClick={
                      fullSearch ? handleBackToList : cancelBookingsAction
                    }
                    disabled={isLoading}
                  >
                    Cancel
                  </Button>
                )}
              </StyledActionControlContainer>
            ) : (
              <ActionHeader>
                <Flex gap={10}>
                  {showBookings && (
                    <Button
                      color="primary"
                      variant="solid"
                      onClick={modifyBookingsAction}
                      disabled={isModifyDisabled}
                    >
                      Modify
                    </Button>
                  )}
                  <DropdownButton
                    items={DropdownButtonItem}
                    buttonText={"Create New"}
                    handleItemClicked={handleScheduledBooking}
                    onButtonClick={newBookingsAction}
                    disabled={isAddDisabled}
                  />
                  {showBookings && (
                    <Button
                      color="primary"
                      type="primary"
                      variant="solid"
                      onClick={handleBackToList}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.VIEW,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        )
                      }
                    >
                      Back to List
                    </Button>
                  )}
                  {showBookings &&
                    !!bookings?.bio?.[0]?.enrolleeId &&
                    !saveVisible && (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        onClick={() => openIrisSearch("verify")}
                        icon={<EyeOutlined />}
                        disabled={!irisDeviceConnected}
                      >
                        Verify Iris
                      </Button>
                    )}
                  {showBookings &&
                    !!bookings?.bio?.[0]?.enrolleeId &&
                    !saveVisible && (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        onClick={handleIrisHistory}
                        icon={<EyeOutlined />}
                        loading={irisHistoryLoading}
                      >
                        Iris History
                      </Button>
                    )}
                </Flex>
                {/* marginLeft: auto keeps this group pinned to the row's
                    right edge (mirrors Transport/Users/Staffing) regardless
                    of whether Show Filter/Clear Filter end up rendering - a
                    bare fragment here would leave individual buttons as
                    direct ActionHeader children, which its own
                    space-between would spread apart instead of keeping
                    paired. */}
                <Flex gap={10} style={{ marginLeft: "auto" }}>
                  {showBookings && (
                    <Search
                      style={{ width: 300 }}
                      placeholder={"Search by Booking Number"}
                      allowClear
                      enterButton="Search"
                      // size="large"
                      onSearch={(e) => onSearch(e)}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.FIND,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        )
                      }
                    />
                  )}

                  {/* Config — reorder/resize columns; see the hook
                      comment above for why this deviates from legacy
                      (Bookings' own main search grid, same category as the
                      other main-search-grid deviations elsewhere in this
                      rollout). Kept left of Clear Filter/Show Filter so
                      Show Filter stays the row's rightmost button. */}
                  {!showBookings &&
                    hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.module,
                      LABELS_CAPITAL.VIEW,
                      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    ) &&
                    (!isConfiguring ? (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        htmlType="button"
                        onClick={startConfiguring}
                      >
                        {configButtonLabel}
                      </Button>
                    ) : (
                      <Popconfirm
                        title="Do you want to save the current list view configuration?"
                        onConfirm={confirmSave}
                        onCancel={discardChanges}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          color="primary"
                          type="primary"
                          variant="solid"
                          htmlType="button"
                        >
                          {configButtonLabel}
                        </Button>
                      </Popconfirm>
                    ))}

                  {!showBookings && isFiltered && (
                    <Button
                      color="primary"
                      type="primary"
                      variant="solid"
                      onClick={handleClearFilter}
                      disabled={
                        !hasCheckSecurity(
                          Security_Types.functionality,
                          Entity_types.module,
                          LABELS_CAPITAL.VIEW,
                          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                        ) || isConfiguring
                      }
                    >
                      Clear Filter
                    </Button>
                  )}

                  {!showBookings &&
                    hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.module,
                      LABELS_CAPITAL.VIEW,
                      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    ) && (
                      <Button
                        color="primary"
                        type="primary"
                        variant="solid"
                        onClick={handleFilter}
                        disabled={
                          !hasCheckSecurity(
                            Security_Types.functionality,
                            Entity_types.module,
                            LABELS_CAPITAL.FIND,
                            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                          ) || isConfiguring
                        }
                      >
                        Show Filter
                      </Button>
                    )}
                </Flex>
              </ActionHeader>
            )}
          </>
        )}
        {!userDetailLoading && (
          <>
            {hasCheckSecurity(
              Security_Types.functionality,
              Entity_types.module,
              LABELS_CAPITAL.VIEW,
              MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            ) ? (
              <>
                {!showBookings && (
                  <ReportList
                    ref={dataTableRef}
                    draggable={isConfiguring}
                    headers={reportListHeaders}
                    results={filteredReportListData}
                    selectBookingNumber={handleSelectBookingNumber}
                    isLoading={reportListLoading}
                    pagination={pagination}
                    setPagination={setPagination}
                    total={reportListTotal}
                    handleChangePagination={handleChangePagination}
                    setSaveVisible={setSaveVisible}
                    handleClear={handleClear}
                    getReportListData={getReportListData}
                    onTableChange={handleTableChange}
                  />
                )}
              </>
            ) : (
              <>{!reportListLoading && <NoAccess moduleName={"bookings"} />}</>
            )}
          </>
        )}

        {showFilter && (
          <BookingsFilter
            isFindModalVisible={showFilter}
            setIsFindModalVisible={setShowFilter}
            onHandleCancel={handleCancel}
            setReportListData={setFilteredReportListData}
            setReportListTotal={setReportListTotal}
            setBookingSearchPayload={setBookingSearchPayload}
            setPagination={setPagination}
            setIsFiltered={setIsFiltered}
            apiModule={MODULES_LIST.BOOKINGS}
            path={MODULES_LIST.BOOKINGS}
            resetSignal={location.state?.resetFilters}
            setReportListLoading={setReportListLoading}
          />
        )}

        {/* Not gated on showBookings - that flag doesn't turn true until
            handleSelectBookingNumber's fetch succeeds, and it's also shared
            with whatever module opened this popup, so it can already be
            true (with THAT module's data) before this fetch even starts.
            isLinkedBookingLoading is seeded synchronously at mount (see its
            useState above) specifically so this takes priority regardless
            of showBookings's current value. */}
        {isLinkedBookingLoading && (
          <div
            style={{
              minHeight: 600,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader themeMode="light" />
          </div>
        )}
        {showBookings && !isLinkedBookingLoading && (
          <Spin spinning={isLoading} className="text-white" tip="Loading...">
            <InmateDetailsContainer accentBorder>
              <StyledBookingsContent>
                <BookingsDetails
                  handleReBook={preRebook}
                  isBQ={isBQ}
                  currentModule={module || "arrest-report"}
                  allFormRef={allFormRef}
                  onNextClickTrigger={onNextClickTrigger}
                  nextBtnRef={nextBtnRef}
                  tabChangeRef={tabChangeRef}
                  nextBookingStep={nextBookingStep}
                  releaseInmate={handleReleaseInmate}
                  takeProperty={takeProperty}
                  releaseAllProperty={releaseAllProperty}
                  fromBookingStep={fromBookingStep}
                  fromFolderDetails={fromFolderDetails}
                  selectedGroup={selectedGroup}
                  setSelectedGroup={setSelectedGroup}
                  currentTabKey={currentTabKey}
                  setCurrentTabKey={setCurrentTabKey}
                />
              </StyledBookingsContent>
            </InmateDetailsContainer>
          </Spin>
        )}
        {isShowTracking && (
          <HouseAndTracksForm
            showDetailsPopup={isShowTracking}
            setShowDetailsPopup={setisShowTracking}
            isLoading={isLoadingHT}
            handleSave={handleSave}
            bookingsFieldsEnabled={true}
            // selectedRow={selectedRow}
            // mode={mode}
            houseFormRef={houseFormRef}
            // isEdit={isEdit}
            // setIsEdit={setIsEdit}
          />
        )}
        {irisHistoryPopupOpen && (
          <SearchIrisDetailsPopup
            irisSearchDetailsPopupOpen={irisHistoryPopupOpen}
            setisSearchIrisDetailsPopupOpen={setIrisHistoryPopupOpen}
            irisSearchData={irisHistoryData}
            header="Iris History"
            readOnly
          />
        )}
      </StyledBookingsContainer>
    );
  },
);

BookingsPage.displayName = "BookingsPage";

export default BookingsPage;
